import React, { Component, Fragment, useCallback, useState, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Redirect, Route, withRouter, Link as Link$2, NavLink } from 'react-router-dom';
import { observable, autorun, trace, toJS, decorate, computed, reaction } from 'mobx';
import cs from 'classnames';
import 'antd/es/avatar/style/css';
import 'antd/es/button/style/css';
import 'antd/es/checkbox/style/css';
import 'antd/es/divider/style/css';
import 'antd/es/empty/style/css';
import 'antd/es/form/style/css';
import 'antd/es/icon/style/css';
import 'antd/es/input/style/css';
import 'antd/es/input-number/style/css';
import 'antd/es/modal/style/css';
import 'antd/es/popconfirm/style/css';
import 'antd/es/result/style/css';
import 'antd/es/select/style/css';
import 'antd/es/spin/style/css';
import 'antd/es/statistic/style/css';
import 'antd/es/steps/style/css';
import 'antd/es/tag/style/css';
import 'antd/es/tooltip/style/css';
import 'antd/es/table/style/css';
import 'antd/es/message/style/css';
import 'antd/es/dropdown/style/css';
import 'antd/es/menu/style/css';
import 'antd/es/switch/style/css';
import 'antd/es/notification/style/css';
import Avatar from 'antd/es/avatar';
export { default as Avatar } from 'antd/es/avatar';
import AutoComplete from 'antd/es/auto-complete';
export { default as AutoComplete } from 'antd/es/auto-complete';
import Button from 'antd/es/button';
export { default as Button } from 'antd/es/button';
import Checkbox from 'antd/es/checkbox';
export { default as Checkbox } from 'antd/es/checkbox';
import Divider from 'antd/es/divider';
export { default as Divider } from 'antd/es/divider';
export { default as Empty } from 'antd/es/empty';
import Form from 'antd/es/form';
export { default as Form } from 'antd/es/form';
import Icon from 'antd/es/icon';
export { default as Icon } from 'antd/es/icon';
import Input from 'antd/es/input';
export { default as Input } from 'antd/es/input';
import InputNumber from 'antd/es/input-number';
export { default as InputNumber } from 'antd/es/input-number';
import Modal from 'antd/es/modal';
export { default as Modal } from 'antd/es/modal';
import Popconfirm from 'antd/es/popconfirm';
export { default as Popconfirm } from 'antd/es/popconfirm';
export { default as Result } from 'antd/es/result';
import Select from 'antd/es/select';
export { default as Select } from 'antd/es/select';
export { default as Statistic } from 'antd/es/statistic';
export { default as Steps } from 'antd/es/steps';
export { default as Spin } from 'antd/es/spin';
import Tag from 'antd/es/tag';
export { default as Tag } from 'antd/es/tag';
import Tooltip from 'antd/es/tooltip';
export { default as Tooltip } from 'antd/es/tooltip';
import Table from 'antd/es/table';
export { default as Table } from 'antd/es/table';
export { default as message } from 'antd/es/message';
import Dropdown from 'antd/es/dropdown';
export { default as Dropdown } from 'antd/es/dropdown';
import Menu from 'antd/es/menu';
export { default as Menu } from 'antd/es/menu';
export { default as Switch } from 'antd/es/switch';
import notification from 'antd/es/notification';
export { default as notification } from 'antd/es/notification';
import qs from 'qs';
import SaasifyClient from 'saasify-client';
import localforage from 'localforage';
import _debug from 'debug';
import { injectStripe, StripeProvider, Elements, CardElement } from 'react-stripe-elements';
import raf from 'raf';
import Hoverable from 'react-event-as-prop/lib/Hoverable';
import slugify from '@sindresorhus/slugify';
import copyTextToClipboard from 'copy-text-to-clipboard';
import { format } from 'date-fns';
import titleize from 'titleize';
import Colr from 'colr';
import random from 'random';
import sizeMe from 'react-sizeme';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/light';
import defaultCodeTheme from 'react-syntax-highlighter/dist/esm/styles/hljs/tomorrow';
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript';
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json';
import python from 'react-syntax-highlighter/dist/esm/languages/hljs/python';
import ruby from 'react-syntax-highlighter/dist/esm/languages/hljs/ruby';
import bash from 'react-syntax-highlighter/dist/esm/languages/hljs/bash';
import mem from 'mem';
import isDeepEqual from 'fast-deep-equal';
import mediumZoom from 'medium-zoom';
import mime from 'mime-types';
import fileType from 'file-type';
import detectCsv from 'detect-csv';
import isHtml from 'is-html';
import download from 'downloadjs';
import ReactFromJSON from 'react-from-json';
import ReactMarkdown from 'react-markdown';
import codeTheme from 'react-syntax-highlighter/dist/esm/styles/hljs/vs2015';
import Editor from 'react-simple-code-editor';
import prettier from 'prettier/standalone';
import prettierBabylon from 'prettier/parser-babylon';
import Fuse from 'fuse.js';
import getServiceExamples from 'saasify-codegen';
import SaasifySDK from 'saasify-faas-sdk';
import ReactDOM from 'react-dom';
import EventEmitter3 from 'eventemitter3';
import ms from 'ms';
import uniqBy from 'lodash.uniqby';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = {
  "section": "okta-module_section__3C6V-",
  "title": "okta-module_title__7O1oG",
  "subtitle": "okta-module_subtitle__2pQn3",
  "content": "okta-module_content__LUjyp",
  "theme-okta": "okta-module_theme-okta__iN0o9",
  "light": "okta-module_light__2w-1n",
  "header": "okta-module_header__1WlW3",
  "link": "okta-module_link___U-L6",
  "detail": "okta-module_detail__2hQvP",
  "cta-button": "okta-module_cta-button__qGo57",
  "live-service-demo": "okta-module_live-service-demo__1XylH",
  "output__cta__message": "okta-module_output__cta__message__2u8dG",
  "footer__service__name": "okta-module_footer__service__name__4ALiU",
  "docs-page": "okta-module_docs-page__3LlBL",
  "logo": "okta-module_logo__2hB_O",
  "logo--light": "okta-module_logo--light__3U9mY",
  "plan": "okta-module_plan__22aI0",
  "features": "okta-module_features__2473Y"
};

var okta = function okta(opts) {
  if (opts === void 0) {
    opts = {};
  }

  return _extends({}, styles, {
    '@name': 'okta',
    '@section-bg': true,
    '@section-fg-color': '#23303a',
    '@section-bg-color': '#1e3a54',
    '@primary-color': '#d23d67'
  }, opts);
};

var themes = {
  __proto__: null,
  okta: okta
};

var _class, _descriptor, _temp;

var ThemeManagerClass = (_class = (_temp = function ThemeManagerClass() {
  var _this = this;

  _initializerDefineProperty(this, "theme", _descriptor, this);

  this._themes = {};

  this.registerTheme = function (name, themeFactory) {
    if (process.env.NODE_ENV === 'development') {
      console.log('register theme', name);
    }

    _this._themes[name] = themeFactory;
  };

  this.setTheme = function (opts) {
    var name;

    if (typeof opts === 'object') {
      name = opts.name;
    } else {
      name = opts;
      opts = {};
    }

    var themeFactory = name && _this._themes[name];

    if (themeFactory) {
      _this.theme = themeFactory(opts);
    } else {
      console.error();
      console.error("ThemeManager.setTheme(" + name + ") theme not found");
      console.error('Must call ThemeManager.registerTheme first');
      console.error();
    }
  };
}, _temp), _descriptor = _applyDecoratedDescriptor(_class.prototype, "theme", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _class);
var ThemeManager = observable(new ThemeManagerClass());
window.ThemeManager = ThemeManager;

for (var _i = 0, _Object$entries = Object.entries(themes); _i < _Object$entries.length; _i++) {
  var _Object$entries$_i = _Object$entries[_i],
      k = _Object$entries$_i[0],
      v = _Object$entries$_i[1];
  ThemeManager.registerTheme(k, v);
}

if (process.env.NODE_ENV === 'development') {
  autorun(function () {
    trace();
    console.log('theme', toJS(ThemeManager.theme));
  }, {
    name: 'Theme change (development)'
  });
}

var themeUtil = function themeUtil(styles, id) {
  var theme = ThemeManager.theme;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return cs.apply(void 0, [styles && styles[id], theme[id]].concat(args));
};

var variables = ['@name', '@section-fg-color', '@section-bg-color', 'light', 'codeTheme', '@primary-color', '@link-color', '@success-color', '@warning-color', '@error-color', '@font-size-base', '@heading-color', '@text-color', '@text-color-secondary ', '@disabled-color ', '@border-radius-base', '@border-color-base', '@box-shadow-base'];

var _loop = function _loop() {
  var v = _variables[_i$1];
  Object.defineProperty(themeUtil, v, {
    get: function get() {
      return ThemeManager.theme[v];
    }
  });
};

for (var _i$1 = 0, _variables = variables; _i$1 < _variables.length; _i$1++) {
  _loop();
}

decorate(themeUtil, variables.reduce(function (acc, k) {
  acc[k] = computed;
  return acc;
}, {}));
var theme = themeUtil;
var styles$1 = {
  "loading": "styles-module_loading__2lJ-K",
  "title": "styles-module_title__3WAEn",
  "loading-icon": "styles-module_loading-icon__2Sw0s"
};

var Loading = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Loading, _Component);

  function Loading() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Loading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        title = _this$props.title,
        rest = _objectWithoutPropertiesLoose(_this$props, ["className", "title"]);

    return h("div", _extends({
      className: themeUtil(styles$1, 'loading', className)
    }, rest), title && h("h3", {
      className: themeUtil(styles$1, 'title', className)
    }, title), h(Icon, {
      className: themeUtil(styles$1, 'loading-icon', className),
      type: "loading"
    }));
  };

  return Loading;
}(Component);

var _dec, _class$1, _class2, _temp$1;

var AuthenticatedRoute = (_dec = inject('auth'), _dec(_class$1 = observer(_class$1 = (_temp$1 = _class2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthenticatedRoute, _Component);

  function AuthenticatedRoute() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AuthenticatedRoute.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        redirect = _this$props.redirect,
        auth = _this$props.auth,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "redirect", "auth"]);

    if (auth.isBootstrapping) {
      return h(Loading, null);
    }

    if (!auth.isAuthenticated) {
      return h(Redirect, {
        to: {
          pathname: redirect
        }
      });
    }

    return h(Route, _extends({}, rest, {
      render: function render(props) {
        return auth.isAuthenticated ? h(Component, props) : h(Redirect, {
          to: {
            pathname: redirect,
            state: {
              from: props.location
            }
          }
        });
      }
    }));
  };

  return AuthenticatedRoute;
}(Component), _class2.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  auth: PropTypes.object.isRequired,
  redirect: PropTypes.string
}, _class2.defaultProps = {
  redirect: '/login'
}, _temp$1)) || _class$1) || _class$1);
var isProd = process.env.NODE_ENV === 'production';
var apiBaseUrl = process.env.REACT_APP_SAASIFY_API_BASE_URL || 'https://api.saasify.sh';
var redirectUri = 'https://auth.saasify.sh';
var githubRedirectUri = window.location.origin + "/auth/github";
var googleRedirectUri = window.location.origin + "/auth/google";
var stripeRedirectUri = window.location.origin + "/auth/stripe";
var spotifyRedirectUri = window.location.origin + "/auth/spotify";
var twitterRedirectUri = window.location.origin + "/auth/twitter";
var linkedinRedirectUri = window.location.origin + "/auth/linkedin";
var githubRedirectQuery = qs.stringify({
  uri: githubRedirectUri
});
var saasifyProviderStripePublicKeyTest = 'pk_test_FvYaeQlk6RbGIL9E36p9xNRo';
var saasifyProviderStripePublicKeyLive = 'pk_live_3vousdHKwzzKdrP0quCQPWcr';
var saasifyProviderStripeClientIdDev = 'ca_GqgriKmt3i5JYrKOaHzJbAceDdB0Yc5k';
var saasifyProviderStripeClientIdPrd = 'ca_Gqgr4b80VSYylXdUDsh548bNb1wqdue8';
var saasifyProviderGitHubClientIdDev = '86d73532d0105da51a4d';
var saasifyProviderGitHubClientIdPrd = '6525c812c9b4430147c3';
var saasifyProviderSpotifyClientIdDev = '99702e2b2d9d45b7bb457b4e8a9e7d68';
var saasifyProviderSpotifyClientIdPrd = '99702e2b2d9d45b7bb457b4e8a9e7d68';
var saasifyProviderLinkedInClientId = '78vssc1d6gg0c2';
var env = {
  isProd: isProd,
  apiBaseUrl: apiBaseUrl,
  redirectUri: redirectUri,
  githubRedirectUri: redirectUri + "?" + githubRedirectQuery,
  providerGitHubClientId: isProd ? saasifyProviderGitHubClientIdPrd : saasifyProviderGitHubClientIdDev,
  googleRedirectUri: googleRedirectUri,
  stripeRedirectUri: stripeRedirectUri,
  providerStripeClientId: isProd ? saasifyProviderStripeClientIdPrd : saasifyProviderStripeClientIdDev,
  stripePublicKey: isProd ? saasifyProviderStripePublicKeyLive : saasifyProviderStripePublicKeyTest,
  spotifyRedirectUri: spotifyRedirectUri,
  providerSpotifyClientId: isProd ? saasifyProviderSpotifyClientIdPrd : saasifyProviderSpotifyClientIdDev,
  twitterRedirectUri: twitterRedirectUri,
  linkedinRedirectUri: linkedinRedirectUri,
  providerLinkedInClientId: saasifyProviderLinkedInClientId
};
var API = new SaasifyClient({
  baseUrl: env.apiBaseUrl
});
var cache = {};

var LocalStore = /*#__PURE__*/function () {
  function LocalStore() {}

  LocalStore.get = function get() {
    var key = arguments.length <= 0 ? undefined : arguments[0];
    var cached = cache[key];
    if (cached) return Promise.resolve(cached);
    var value = localforage.getItem.apply(localforage, arguments);
    cache[key] = value;
    return value;
  };

  LocalStore.set = function set() {
    var key = arguments.length <= 0 ? undefined : arguments[0];
    var value = arguments.length <= 1 ? undefined : arguments[1];
    cache[key] = value;
    return localforage.setItem.apply(localforage, arguments);
  };

  LocalStore.remove = function remove() {
    var key = arguments.length <= 0 ? undefined : arguments[0];
    delete cache[key];
    return localforage.removeItem.apply(localforage, arguments);
  };

  return LocalStore;
}();

var authTwitter = function authTwitter(_ref7) {
  var location = _ref7.location;

  try {
    var stateRaw = JSON.stringify({
      uri: env.twitterRedirectUri,
      route: location.pathname
    });
    var state = btoa(stateRaw);
    var params = {
      state: state
    };
    var opts = qs.stringify(params);
    var redirectUri = env.redirectUri + "?" + opts;
    return Promise.resolve(API.getTwitterAuthUrl({
      redirectUri: redirectUri
    })).then(function (_ref8) {
      var authUrl = _ref8.url;
      console.log({
        redirectUri: redirectUri,
        authUrl: authUrl
      });
      return Promise.resolve(storeState()).then(function () {
        window.location = authUrl;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var authSpotify = function authSpotify(_ref6) {
  var location = _ref6.location,
      _ref6$scope = _ref6.scope,
      scope = _ref6$scope === void 0 ? '' : _ref6$scope;

  try {
    var stateRaw = JSON.stringify({
      uri: env.spotifyRedirectUri,
      route: location.pathname
    });
    var state = btoa(stateRaw);
    var params = {
      response_type: 'code',
      client_id: env.providerSpotifyClientId,
      redirect_uri: env.redirectUri,
      scope: scope,
      state: state
    };
    var opts = qs.stringify(params);
    return Promise.resolve(storeState()).then(function () {
      window.location = "https://accounts.spotify.com/authorize?" + opts;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var authStripe = function authStripe(_ref5) {
  var location = _ref5.location,
      auth = _ref5.auth,
      _ref5$express = _ref5.express,
      express = _ref5$express === void 0 ? false : _ref5$express;

  try {
    var stateRaw = JSON.stringify({
      uri: env.stripeRedirectUri,
      route: location.pathname
    });
    var state = btoa(stateRaw);
    var scope = express ? undefined : 'read_write';
    var params = {
      response_type: 'code',
      client_id: env.providerStripeClientId,
      scope: scope,
      state: state
    };

    if (auth) {
      var _auth$user;

      params['stripe_user[email]'] = (_auth$user = auth.user) === null || _auth$user === void 0 ? void 0 : _auth$user.email;
    }

    var opts = qs.stringify(params);
    return Promise.resolve(storeState()).then(function () {
      if (express) {
        window.location = "https://connect.stripe.com/express/oauth/authorize?" + opts;
      } else {
        window.location = "https://connect.stripe.com/oauth/authorize?" + opts;
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var authGoogle = function authGoogle(_ref3, params) {
  var location = _ref3.location;

  try {
    return Promise.resolve(API.getGoogleAuthUrl(params)).then(function (_ref4) {
      var url = _ref4.url;
      var authUrl = new URL(url);
      var state = JSON.stringify({
        uri: env.googleRedirectUri,
        route: location.pathname
      });
      var state64 = btoa(state);
      authUrl.searchParams.set('state', state64);
      var finalUrl = authUrl.toString();
      console.log('authenticating with google', {
        url: url,
        finalUrl: finalUrl
      });
      return Promise.resolve(storeState()).then(function () {
        window.location = finalUrl;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var authLinkedIn = function authLinkedIn(_ref2) {
  var location = _ref2.location;

  try {
    var scope = 'r_liteprofile r_emailaddress';
    var stateRaw = JSON.stringify({
      uri: env.linkedinRedirectUri,
      route: location.pathname
    });
    var state = btoa(stateRaw);
    var opts = qs.stringify({
      client_id: env.providerLinkedInClientId,
      redirect_uri: env.redirectUri,
      response_type: 'code',
      scope: scope,
      state: state
    });
    return Promise.resolve(storeState()).then(function () {
      window.location = "https://www.linkedin.com/oauth/v2/authorization?" + opts;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var authGitHub = function authGitHub(_ref) {
  try {
    var scope = 'read:user user:email';
    var opts = qs.stringify(_extends({}, githubConfig, {
      scope: scope
    }));
    return Promise.resolve(storeState()).then(function () {
      window.location = "https://github.com/login/oauth/authorize?" + opts;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var storeState = function storeState() {
  try {
    return Promise.resolve(LocalStore.set(storeKey, window.location.href));
  } catch (e) {
    return Promise.reject(e);
  }
};

var storeKey = 'auth:location';
var githubConfig = {
  client_id: env.providerGitHubClientId,
  redirect_uri: env.githubRedirectUri
};

var debug = _debug('app');

var styles$2 = {
  "form": "styles-module_form__yUzwU",
  "title": "styles-module_title__muMf6",
  "forgot": "styles-module_forgot__7hJYu",
  "submit": "styles-module_submit__1k3Id",
  "or-signup": "styles-module_or-signup__dvibh"
};

var _dec$1, _dec2, _class$2, _class2$1, _temp$2;

var FormItem = Form.Item;
var LoginForm = (_dec$1 = inject('auth'), _dec2 = Form.create(), _dec$1(_class$2 = withRouter(_class$2 = _dec2(_class$2 = (_temp$2 = _class2$1 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LoginForm, _Component);

  function LoginForm() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: false
    };

    _this._onSubmit = function (e) {
      e.preventDefault();

      _this.props.form.validateFields(function (err, data) {
        if (!err) {
          _this.setState({
            loading: true
          });

          _this.props.auth.signin(data).then(_this.props.onAuth)["catch"](function (err) {
            var _err$response, _err$response$data;

            debug(err);

            _this.setState({
              loading: false
            });

            notification.error({
              message: 'Error logging in',
              description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message,
              duration: 10
            });
          });
        }
      });
    };

    _this._onClickGitHub = function (e) {
      e.preventDefault();
      authGitHub();
    };

    _this._onClickGoogle = function (e) {
      e.preventDefault();
      authGoogle({
        location: _this.props.location
      }, _this.props.authParams);
    };

    _this._onClickTwitter = function (e) {
      e.preventDefault();
      authTwitter({
        location: _this.props.location
      });
    };

    _this._onClickLinkedIn = function (e) {
      e.preventDefault();
      authLinkedIn({
        location: _this.props.location
      });
    };

    return _this;
  }

  var _proto = LoginForm.prototype;

  _proto.render = function render() {
    var _authConfig$github, _authConfig$google, _authConfig$twitter, _authConfig$linkedin, _authConfig$default;

    var _this$props = this.props,
        className = _this$props.className,
        authConfig = _this$props.authConfig;
    var getFieldDecorator = this.props.form.getFieldDecorator;
    var loading = this.state.loading;
    var iconUser = h(Icon, {
      type: "user",
      style: {
        color: 'rgba(0,0,0,.25)'
      }
    });
    var iconLock = h(Icon, {
      type: "lock",
      style: {
        color: 'rgba(0,0,0,.25)'
      }
    });
    var hasGitHubAuth = ((_authConfig$github = authConfig.github) === null || _authConfig$github === void 0 ? void 0 : _authConfig$github.enabled) !== false;
    var hasGoogleAuth = ((_authConfig$google = authConfig.google) === null || _authConfig$google === void 0 ? void 0 : _authConfig$google.enabled) !== false;
    var hasTwitterAuth = ((_authConfig$twitter = authConfig.twitter) === null || _authConfig$twitter === void 0 ? void 0 : _authConfig$twitter.enabled) !== false;
    var hasLinkedInAuth = ((_authConfig$linkedin = authConfig.linkedin) === null || _authConfig$linkedin === void 0 ? void 0 : _authConfig$linkedin.enabled) !== false;
    var hasDefaultAuth = ((_authConfig$default = authConfig["default"]) === null || _authConfig$default === void 0 ? void 0 : _authConfig$default.enabled) !== false;
    return h(Form, {
      className: themeUtil(styles$2, 'form', themeUtil.light, className),
      onSubmit: this._onSubmit
    }, h("h2", {
      className: themeUtil(styles$2, 'title')
    }, "Login"), authConfig.preBody, hasGitHubAuth && h(FormItem, null, h(Button, {
      className: themeUtil(styles$2, 'submit'),
      icon: "github",
      onClick: this._onClickGitHub
    }, "Log in with GitHub")), hasGoogleAuth && h(FormItem, null, h(Button, {
      className: themeUtil(styles$2, 'submit'),
      icon: "google",
      onClick: this._onClickGoogle
    }, "Log in with Google")), hasTwitterAuth && h(FormItem, null, h(Button, {
      className: themeUtil(styles$2, 'submit'),
      icon: "twitter",
      onClick: this._onClickTwitter
    }, "Log in with Twitter")), hasLinkedInAuth && h(FormItem, null, h(Button, {
      className: themeUtil(styles$2, 'submit'),
      icon: "linkedin",
      onClick: this._onClickLinkedIn
    }, "Log in with LinkedIn")), (hasGitHubAuth || hasGoogleAuth || hasTwitterAuth || hasLinkedInAuth) && hasDefaultAuth && h(Divider, null, "Or"), hasDefaultAuth && h(React.Fragment, null, h(FormItem, null, getFieldDecorator('username', {
      rules: [{
        required: true,
        message: 'Please enter your username or email.'
      }]
    })(h(Input, {
      prefix: iconUser,
      placeholder: "Username"
    }))), h(FormItem, null, getFieldDecorator('password', {
      rules: [{
        required: true,
        message: 'Please enter your password.'
      }]
    })(h(Input, {
      prefix: iconLock,
      type: "password",
      placeholder: "Password"
    }))), h(FormItem, null, getFieldDecorator('remember', {
      valuePropName: 'checked',
      initialValue: true
    })(h(Checkbox, null, "Remember me"))), h(Button, {
      type: "primary",
      htmlType: "submit",
      className: themeUtil(styles$2, 'submit'),
      loading: loading
    }, "Log in")), authConfig.orSignup !== false && h("div", {
      className: themeUtil(styles$2, 'or-signup')
    }, authConfig.orSignup || h("span", null, "Or ", h(Link$2, {
      to: "/signup"
    }, "sign up!"))), authConfig.postBody);
  };

  return LoginForm;
}(Component), _class2$1.propTypes = {
  auth: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  authConfig: PropTypes.object,
  authParams: PropTypes.object,
  className: PropTypes.string,
  onAuth: PropTypes.func
}, _class2$1.defaultProps = {
  authConfig: {},
  authParams: {},
  onAuth: function onAuth() {
    return undefined;
  }
}, _temp$2)) || _class$2) || _class$2) || _class$2);
var styles$3 = {
  "form": "styles-module_form__QEYKq",
  "title": "styles-module_title__2b9xU",
  "submit": "styles-module_submit__2hmyi"
};

var _dec$2, _dec2$1, _class$3, _class2$2, _temp$3;

var FormItem$1 = Form.Item;
var SignupForm = (_dec$2 = inject('auth'), _dec2$1 = Form.create(), _dec$2(_class$3 = withRouter(_class$3 = _dec2$1(_class$3 = (_temp$3 = _class2$2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SignupForm, _Component);

  function SignupForm() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: false
    };

    _this._onSubmit = function (e) {
      e.preventDefault();

      _this.props.form.validateFields(function (err, data) {
        if (!err) {
          _this.setState({
            loading: true
          });

          _this.props.auth.signup(data).then(_this.props.onAuth)["catch"](function (err) {
            var _err$response, _err$response$data;

            debug(err);

            _this.setState({
              loading: false
            });

            notification.error({
              message: 'Error signing up',
              description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message,
              duration: 10
            });
          });
        }
      });
    };

    _this._onClickGitHub = function (e) {
      e.preventDefault();
      authGitHub();
    };

    _this._onClickGoogle = function (e) {
      e.preventDefault();
      authGoogle({
        location: _this.props.location
      }, _this.props.authParams);
    };

    _this._onClickTwitter = function (e) {
      e.preventDefault();
      authTwitter({
        location: _this.props.location
      });
    };

    _this._onClickLinkedIn = function (e) {
      e.preventDefault();
      authLinkedIn({
        location: _this.props.location
      });
    };

    return _this;
  }

  var _proto = SignupForm.prototype;

  _proto.render = function render() {
    var _authConfig$github, _authConfig$google, _authConfig$twitter, _authConfig$linkedin, _authConfig$default;

    var _this$props = this.props,
        className = _this$props.className,
        authConfig = _this$props.authConfig;
    var getFieldDecorator = this.props.form.getFieldDecorator;
    var loading = this.state.loading;
    var iconUser = h(Icon, {
      type: "user",
      style: {
        color: 'rgba(0,0,0,.25)'
      }
    });
    var iconLock = h(Icon, {
      type: "lock",
      style: {
        color: 'rgba(0,0,0,.25)'
      }
    });
    var hasGitHubAuth = ((_authConfig$github = authConfig.github) === null || _authConfig$github === void 0 ? void 0 : _authConfig$github.enabled) !== false;
    var hasGoogleAuth = ((_authConfig$google = authConfig.google) === null || _authConfig$google === void 0 ? void 0 : _authConfig$google.enabled) !== false;
    var hasTwitterAuth = ((_authConfig$twitter = authConfig.twitter) === null || _authConfig$twitter === void 0 ? void 0 : _authConfig$twitter.enabled) !== false;
    var hasLinkedInAuth = ((_authConfig$linkedin = authConfig.linkedin) === null || _authConfig$linkedin === void 0 ? void 0 : _authConfig$linkedin.enabled) !== false;
    var hasDefaultAuth = ((_authConfig$default = authConfig["default"]) === null || _authConfig$default === void 0 ? void 0 : _authConfig$default.enabled) !== false;
    return h(Form, {
      className: themeUtil(styles$3, 'form', themeUtil.light, className),
      onSubmit: this._onSubmit
    }, h("h2", {
      className: themeUtil(styles$3, 'title')
    }, "Sign up"), authConfig.preBody, hasGitHubAuth && h(FormItem$1, null, h(Button, {
      className: themeUtil(styles$3, 'submit'),
      icon: "github",
      onClick: this._onClickGitHub
    }, "Sign up with GitHub")), hasGoogleAuth && h(FormItem$1, null, h(Button, {
      className: themeUtil(styles$3, 'submit'),
      icon: "google",
      onClick: this._onClickGoogle
    }, "Sign up with Google")), hasTwitterAuth && h(FormItem$1, null, h(Button, {
      className: themeUtil(styles$3, 'submit'),
      icon: "twitter",
      onClick: this._onClickTwitter
    }, "Sign up with Twitter")), hasLinkedInAuth && h(FormItem$1, null, h(Button, {
      className: themeUtil(styles$3, 'submit'),
      icon: "linkedin",
      onClick: this._onClickLinkedIn
    }, "Sign up with LinkedIn")), (hasGitHubAuth || hasGoogleAuth || hasTwitterAuth || hasLinkedInAuth) && hasDefaultAuth && h(Divider, null, "Or"), hasDefaultAuth && h(React.Fragment, null, h(FormItem$1, null, getFieldDecorator('email', {
      rules: [{
        required: true,
        message: 'Please enter your email.'
      }]
    })(h(Input, {
      prefix: iconUser,
      placeholder: "Email"
    }))), h(FormItem$1, null, getFieldDecorator('username', {
      rules: [{
        required: true,
        message: 'Please enter a username.'
      }]
    })(h(Input, {
      prefix: iconUser,
      placeholder: "Username"
    }))), h(FormItem$1, null, getFieldDecorator('password', {
      rules: [{
        required: true,
        message: 'Please enter a password.'
      }]
    })(h(Input, {
      prefix: iconLock,
      type: "password",
      placeholder: "Password"
    }))), h(FormItem$1, null, getFieldDecorator('remember', {
      valuePropName: 'checked',
      initialValue: true
    })(h(Checkbox, null, "Remember me"))), h(Button, {
      type: "primary",
      htmlType: "submit",
      className: themeUtil(styles$3, 'submit'),
      loading: loading
    }, "Sign up")), authConfig.postBody);
  };

  return SignupForm;
}(Component), _class2$2.propTypes = {
  auth: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  authConfig: PropTypes.object,
  authParams: PropTypes.object,
  className: PropTypes.string,
  onAuth: PropTypes.func
}, _class2$2.defaultProps = {
  authConfig: {},
  authParams: {},
  onAuth: function onAuth() {
    return undefined;
  }
}, _temp$3)) || _class$3) || _class$3) || _class$3);
var styles$4 = {
  "form": "styles-module_form__IMIw5",
  "title": "styles-module_title__202A0",
  "submit": "styles-module_submit__3cAJZ",
  "label": "styles-module_label__1mKjb",
  "input": "styles-module_input__2PQy2",
  "detail": "styles-module_detail__1-Z3w"
};

var _dec$3, _class$4, _class2$3, _temp$4, _class3, _class4, _temp2;

var createOptions = function createOptions(fontSize) {
  if (fontSize === void 0) {
    fontSize = 16;
  }

  return {
    style: {
      base: {
        fontSize: fontSize,
        color: '#424770',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#9e2146'
      }
    }
  };
};

var CheckoutForm = (_dec$3 = inject('config'), _dec$3(_class$4 = observer(_class$4 = (_temp$4 = _class2$3 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CheckoutForm, _Component);

  function CheckoutForm() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = CheckoutForm.prototype;

  _proto.render = function render() {
    return h(StripeProvider, {
      apiKey: env.stripePublicKey
    }, h(Elements, null, h(CheckoutFormImpl, this.props)));
  };

  return CheckoutForm;
}(Component), _class2$3.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string,
  action: PropTypes.node,
  className: PropTypes.string,
  config: PropTypes.object.isRequired
}, _temp$4)) || _class$4) || _class$4);

var CheckoutFormImpl = injectStripe(_class3 = (_temp2 = _class4 = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(CheckoutFormImpl, _Component2);

  function CheckoutFormImpl() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component2.call.apply(_Component2, [this].concat(args)) || this;

    _this._onSubmit = function (e) {
      try {
        e.preventDefault();
        var name = e.target.name.value;
        var coupon = e.target.coupon && e.target.coupon.value;

        _this.props.onSubmit({
          name: name,
          coupon: coupon,
          stripe: _this.props.stripe
        });

        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    };

    return _this;
  }

  var _proto2 = CheckoutFormImpl.prototype;

  _proto2.render = function render() {
    var _this$props = this.props,
        config = _this$props.config,
        loading = _this$props.loading,
        title = _this$props.title,
        action = _this$props.action,
        className = _this$props.className;
    return h("form", {
      className: themeUtil(styles$4, 'form', className, themeUtil(styles$4, 'light')),
      onSubmit: this._onSubmit
    }, title && h("h2", {
      className: themeUtil(styles$4, 'title')
    }, title), h("label", {
      className: themeUtil(styles$4, 'label')
    }, "Name", h("input", {
      className: themeUtil(styles$4, 'input'),
      name: "name",
      type: "text",
      placeholder: "John Doe",
      required: true
    })), h("label", {
      className: themeUtil(styles$4, 'label')
    }, "Card Details", h(Tooltip, {
      placement: "right",
      title: "All payment info is securely handled by Stripe."
    }, h(Icon, {
      className: themeUtil(styles$4, 'detail'),
      type: "question-circle"
    })), h(CardElement, createOptions())), config.coupons && config.coupons.length > 0 && h("label", {
      className: themeUtil(styles$4, 'label')
    }, "Promo Code", h("input", {
      className: themeUtil(styles$4, 'input'),
      name: "coupon",
      type: "text",
      placeholder: ""
    })), action && h(Button, {
      type: "primary",
      htmlType: "submit",
      className: themeUtil(styles$4, 'submit'),
      loading: loading
    }, action));
  };

  return CheckoutFormImpl;
}(Component), _class4.propTypes = {
  config: PropTypes.object.isRequired,
  stripe: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string,
  action: PropTypes.node,
  className: PropTypes.string
}, _class4.defaultProps = {
  loading: false
}, _temp2)) || _class3;

var styles$5 = {
  "cta-button": "styles-module_cta-button__3AKzj",
  "inline": "styles-module_inline__1QeA5"
};

var _class$5;

var CTAButton = Hoverable(_class$5 = observer(_class$5 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CTAButton, _Component);

  function CTAButton() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = CTAButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        hovered = _this$props.hovered,
        _this$props$type = _this$props.type,
        type = _this$props$type === void 0 ? 'primary' : _this$props$type,
        inline = _this$props.inline,
        className = _this$props.className,
        children = _this$props.children,
        _this$props$style = _this$props.style,
        style = _this$props$style === void 0 ? {} : _this$props$style,
        rest = _objectWithoutPropertiesLoose(_this$props, ["hovered", "type", "inline", "className", "children", "style"]);

    var primaryColor = themeUtil['@primary-color'];
    var borderColor = type === 'secondary' || !hovered ? primaryColor : 'transparent';
    var ownStyle = {
      border: "2px solid " + borderColor
    };

    if (type === 'secondary') {
      ownStyle.background = hovered ? primaryColor : 'transparent';
    }

    return h(Button, _extends({
      type: type,
      className: themeUtil(styles$5, 'cta-button', className, type, styles$5[type], inline && themeUtil(styles$5, 'inline')),
      style: _extends({}, ownStyle, {}, style)
    }, rest), children);
  };

  return CTAButton;
}(Component)) || _class$5) || _class$5;

var styles$6 = {
  "logo": "styles-module_logo__CDiMd"
};

var _dec$4, _class$6;

var Logo = (_dec$4 = inject('config'), _dec$4(_class$6 = observer(_class$6 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Logo, _Component);

  function Logo() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Logo.prototype;

  _proto.render = function render() {
    var _config$deployment, _config$deployment$sa;

    var _this$props = this.props,
        className = _this$props.className,
        _this$props$style = _this$props.style,
        style = _this$props$style === void 0 ? {} : _this$props$style,
        light = _this$props.light,
        config = _this$props.config,
        rest = _objectWithoutPropertiesLoose(_this$props, ["className", "style", "light", "config"]);

    return config.logo ? h("img", _extends({
      className: themeUtil(styles$6, 'logo', className),
      src: light && ((_config$deployment = config.deployment) === null || _config$deployment === void 0 ? void 0 : (_config$deployment$sa = _config$deployment.saas) === null || _config$deployment$sa === void 0 ? void 0 : _config$deployment$sa.logoLight) || config.logo,
      alt: config.name + " Logo",
      style: style
    }, rest)) : h("div", _extends({
      className: themeUtil(styles$6, 'logo', className),
      style: style
    }, rest), config.name);
  };

  return Logo;
}(Component)) || _class$6) || _class$6);
var styles$7 = {
  "nav-header": "styles-module_nav-header__1B5br",
  "content": "styles-module_content__1AUWq",
  "content-body": "styles-module_content-body__1Omfb",
  "attached": "styles-module_attached__2xShN",
  "primary": "styles-module_primary__1cin0",
  "logo-image": "styles-module_logo-image__2ur8t",
  "logo": "styles-module_logo__3yU03",
  "logo--light": "styles-module_logo--light__3Pv3B",
  "logo-text": "styles-module_logo-text__KGXVL",
  "links": "styles-module_links__3DD6V",
  "link": "styles-module_link__oAvSn",
  "active-link": "styles-module_active-link__1Hooy",
  "container": "styles-module_container__2vHAE",
  "menuWrapper": "styles-module_menuWrapper__2252q",
  "actions": "styles-module_actions__RSgiO",
  "action": "styles-module_action__3O1Yp",
  "burger": "styles-module_burger__1fkY1",
  "icon": "styles-module_icon__3CHwg",
  "expanded": "styles-module_expanded__39KUP"
};

var Link = function Link(_ref) {
  var children = _ref.children,
      label = _ref.label,
      to = _ref.to,
      href = _ref.href,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "label", "to", "href", "className"]);

  return to ? h(NavLink, _extends({
    to: to,
    className: themeUtil(styles$7, 'link', className),
    activeClassName: themeUtil(styles$7, 'active-link', className),
    exact: true
  }, rest), label || children) : h("a", _extends({
    href: href,
    className: themeUtil(styles$7, 'link', className)
  }, rest), label || children);
};

var _dec$5, _dec2$2, _class$7, _class2$4, _temp$5;

var isServer = typeof window === 'undefined';
var NavHeader = (_dec$5 = inject('config'), _dec2$2 = inject('auth'), _dec$5(_class$7 = _dec2$2(_class$7 = observer(_class$7 = (_temp$5 = _class2$4 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavHeader, _Component);

  function NavHeader() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      attached: isServer || window.scrollY > 0,
      expanded: false,
      width: isServer ? 1000 : window.clientWidth || window.innerWidth
    };

    _this._onToggleMainNav = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    };

    _this._onScroll = function () {
      if (!_this._resetRaf) {
        _this._resetRaf = raf(_this._onReset);
      }
    };

    _this._onResize = function () {
      if (!_this._resetRaf) {
        _this._resetRaf = raf(_this._onReset);
      }
    };

    _this._onReset = function () {
      _this._resetRaf = null;

      _this.setState({
        attached: isServer || window.scrollY > 0,
        width: window.clientWidth || window.innerWidth
      });
    };

    return _this;
  }

  var _proto = NavHeader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!isServer) {
      window.addEventListener('scroll', this._onScroll);
      window.addEventListener('resize', this._onResize);

      this._onReset();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (!isServer) {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    if (this._resetRaf) {
      raf.cancel(this._resetRaf);
      this._resetRaf = null;
    }
  };

  _proto.render = function render() {
    var _config$deployment, _config$deployment$sa, _config$header, _sections$navHeader, _config$header2, _sections$navHeader2, _config$deployment2, _config$deployment2$s;

    var _this$props = this.props,
        auth = _this$props.auth,
        config = _this$props.config,
        fixed = _this$props.fixed,
        className = _this$props.className;
    var _this$state = this.state,
        attached = _this$state.attached,
        expanded = _this$state.expanded,
        width = _this$state.width;
    var sections = config === null || config === void 0 ? void 0 : (_config$deployment = config.deployment) === null || _config$deployment === void 0 ? void 0 : (_config$deployment$sa = _config$deployment.saas) === null || _config$deployment$sa === void 0 ? void 0 : _config$deployment$sa.sections;
    var actions = ((_config$header = config.header) === null || _config$header === void 0 ? void 0 : _config$header.actions) || [];

    if (typeof actions === 'function') {
      actions = actions({
        config: config,
        auth: auth,
        fixed: fixed,
        attached: attached
      });
    }

    var actionsMenu = actions && auth.isAuthenticated && h(Menu, {
      onClick: function onClick(e) {
        return console.log(e);
      }
    }, actions.map(function (action, index) {
      if (typeof action === 'function') {
        action = action({
          config: config,
          auth: auth,
          fixed: fixed,
          attached: attached
        });
        if (!action) return null;
      }

      var _action = action,
          to = _action.to,
          href = _action.href,
          label = _action.label,
          icon = _action.icon,
          rest = _objectWithoutPropertiesLoose(_action, ["key", "to", "href", "label", "icon"]);

      var validKey = action.key || action.to || action.href || index;
      return h(Menu.Item, {
        key: validKey
      }, h(Link, _extends({
        key: validKey,
        to: to,
        href: href
      }, rest), icon && h(Icon, {
        type: icon,
        className: styles$7.icon
      }), label));
    }));
    return h("header", {
      className: themeUtil(styles$7, 'nav-header', attached || fixed ? themeUtil(styles$7, 'attached') : null, expanded ? themeUtil(styles$7, 'expanded') : null, className),
      style: {
        background: attached || fixed || expanded ? themeUtil['@section-fg-color'] : 'transparent',
        paddingBottom: expanded ? 24 : undefined
      }
    }, h("div", {
      className: themeUtil(styles$7, 'content')
    }, h("div", {
      className: themeUtil(styles$7, 'primary')
    }, h(Link, {
      to: "/"
    }, config.logo && (sections === null || sections === void 0 ? void 0 : (_sections$navHeader = sections.navHeader) === null || _sections$navHeader === void 0 ? void 0 : _sections$navHeader.logo) !== false && h("span", {
      className: themeUtil(styles$7, 'logo-image')
    }, h(Logo, {
      className: themeUtil(styles$7, 'logo')
    }), h(Logo, {
      className: themeUtil(styles$7, 'logo', themeUtil(styles$7, 'logo--light')),
      light: true
    })), config.logo && (config === null || config === void 0 ? void 0 : (_config$header2 = config.header) === null || _config$header2 === void 0 ? void 0 : _config$header2.displayName) !== false && (sections === null || sections === void 0 ? void 0 : (_sections$navHeader2 = sections.navHeader) === null || _sections$navHeader2 === void 0 ? void 0 : _sections$navHeader2.displayName) !== false && h("span", {
      className: themeUtil(styles$7, 'logo-text')
    }, (config === null || config === void 0 ? void 0 : (_config$deployment2 = config.deployment) === null || _config$deployment2 === void 0 ? void 0 : (_config$deployment2$s = _config$deployment2.saas) === null || _config$deployment2$s === void 0 ? void 0 : _config$deployment2$s.headerName) ? config.deployment.saas.headerName : config === null || config === void 0 ? void 0 : config.name)), h("div", {
      className: themeUtil(styles$7, 'burger')
    }, h(Button, {
      type: "secondary",
      onClick: this._onToggleMainNav,
      icon: "menu"
    }))), h("div", {
      className: themeUtil(styles$7, 'content-body')
    }, h("div", {
      className: themeUtil(styles$7, 'links')
    }, config.header.links.map(function (link) {
      if (typeof link === 'function') {
        link = link({
          config: config,
          auth: auth,
          fixed: fixed,
          attached: attached
        });
        if (!link) return null;
      }

      var _link = link,
          label = _link.label,
          rest = _objectWithoutPropertiesLoose(_link, ["label", "icon"]);

      return h(Link, _extends({
        key: link.to || link.href
      }, rest), label);
    })), actions ? expanded && width < 768 || !auth.isAuthenticated ? h("div", {
      className: themeUtil(styles$7, 'actions')
    }, actions.map(function (action, index) {
      if (typeof action === 'function') {
        action = action({
          config: config,
          auth: auth,
          fixed: fixed,
          attached: attached
        });
        if (!action) return null;
      }

      var _action2 = action,
          to = _action2.to,
          href = _action2.href,
          label = _action2.label,
          rest = _objectWithoutPropertiesLoose(_action2, ["key", "to", "href", "label", "icon"]);

      var validKey = action.key || action.to || action.href || index;
      var isLink = to || href;
      var className = themeUtil(styles$7, 'action');
      var buttonClassName = isLink ? null : className;
      var button = h(CTAButton, _extends({
        key: validKey,
        inline: true,
        className: buttonClassName
      }, rest), label);

      if (to || href) {
        return h(Link, {
          className: className,
          key: validKey,
          to: to,
          href: href
        }, button);
      } else {
        return button;
      }
    })) : h(Dropdown, {
      placement: "bottomRight",
      trigger: ['click'],
      overlay: actionsMenu
    }, h(Button, {
      type: "secondary"
    }, h(Icon, {
      type: "user"
    }), auth.user.username, h(Icon, {
      type: "down"
    }))) : null)));
  };

  return NavHeader;
}(Component), _class2$4.propTypes = {
  config: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  fixed: PropTypes.bool
}, _class2$4.defaultProps = {
  fixed: false
}, _temp$5)) || _class$7) || _class$7) || _class$7);
var styles$8 = {
  "nav-footer": "styles-module_nav-footer__2rzbL",
  "content": "styles-module_content__3N4wM",
  "header": "styles-module_header__1as3z",
  "listItem": "styles-module_listItem__GSzET",
  "link": "styles-module_link__37mj5",
  "active-link": "styles-module_active-link__3P72p",
  "logo": "styles-module_logo__3-Ksc",
  "detail": "styles-module_detail__2O5Bo"
};

var Link$1 = function Link$1(_ref) {
  var children = _ref.children,
      label = _ref.label,
      to = _ref.to,
      href = _ref.href,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "label", "to", "href", "className"]);

  return to ? h(NavLink, _extends({
    to: to,
    className: themeUtil(styles$8, 'link', className),
    activeClassName: themeUtil(styles$8, 'active-link', className),
    exact: true
  }, rest), label || children) : h("a", _extends({
    href: href,
    className: themeUtil(styles$8, 'link', className)
  }, rest), label || children);
};

var _dec$6, _dec2$3, _class$8, _class2$5, _temp$6;

var NavFooter = (_dec$6 = inject('auth'), _dec2$3 = inject('config'), _dec$6(_class$8 = _dec2$3(_class$8 = observer(_class$8 = (_temp$6 = _class2$5 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavFooter, _Component);

  function NavFooter() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = NavFooter.prototype;

  _proto.render = function render() {
    var _config$deployment, _config$deployment$sa, _config$deployment$sa2, _config$deployment$sa3, _config$deployment2, _config$deployment2$s, _config$deployment2$s2, _config$deployment2$s3, _config$deployment3, _config$deployment3$s, _config$deployment3$s2, _config$deployment3$s3, _config$footer, _config$footer$column;

    var _this$props = this.props,
        auth = _this$props.auth,
        className = _this$props.className,
        inverted = _this$props.inverted,
        style = _this$props.style,
        config = _this$props.config;
    return h("footer", {
      className: themeUtil(styles$8, 'nav-footer', className),
      style: _extends({
        background: inverted ? themeUtil['@section-bg-color'] : themeUtil['@section-fg-color']
      }, style)
    }, h("div", {
      className: themeUtil(styles$8, 'content')
    }, h("div", {
      className: themeUtil(styles$8, 'detailColumn')
    }, config.logo && (config === null || config === void 0 ? void 0 : (_config$deployment = config.deployment) === null || _config$deployment === void 0 ? void 0 : (_config$deployment$sa = _config$deployment.saas) === null || _config$deployment$sa === void 0 ? void 0 : (_config$deployment$sa2 = _config$deployment$sa.sections) === null || _config$deployment$sa2 === void 0 ? void 0 : (_config$deployment$sa3 = _config$deployment$sa2.navFooter) === null || _config$deployment$sa3 === void 0 ? void 0 : _config$deployment$sa3.logo) !== false && h(Link$1, {
      to: "/"
    }, h(Logo, {
      className: themeUtil(styles$8, 'logo')
    })), (config === null || config === void 0 ? void 0 : (_config$deployment2 = config.deployment) === null || _config$deployment2 === void 0 ? void 0 : (_config$deployment2$s = _config$deployment2.saas) === null || _config$deployment2$s === void 0 ? void 0 : (_config$deployment2$s2 = _config$deployment2$s.sections) === null || _config$deployment2$s2 === void 0 ? void 0 : (_config$deployment2$s3 = _config$deployment2$s2.navFooter) === null || _config$deployment2$s3 === void 0 ? void 0 : _config$deployment2$s3.location) !== false && h("div", {
      className: themeUtil(styles$8, 'detail')
    }, (config === null || config === void 0 ? void 0 : (_config$deployment3 = config.deployment) === null || _config$deployment3 === void 0 ? void 0 : (_config$deployment3$s = _config$deployment3.saas) === null || _config$deployment3$s === void 0 ? void 0 : (_config$deployment3$s2 = _config$deployment3$s.sections) === null || _config$deployment3$s2 === void 0 ? void 0 : (_config$deployment3$s3 = _config$deployment3$s2.navFooter) === null || _config$deployment3$s3 === void 0 ? void 0 : _config$deployment3$s3.location) || 'Brooklyn, NY')), (_config$footer = config.footer) === null || _config$footer === void 0 ? void 0 : (_config$footer$column = _config$footer.columns) === null || _config$footer$column === void 0 ? void 0 : _config$footer$column.map(function (column) {
      var _column$links;

      return h("div", {
        key: column.label
      }, h("h3", {
        className: themeUtil(styles$8, 'header')
      }, column.label), h("ul", null, column === null || column === void 0 ? void 0 : (_column$links = column.links) === null || _column$links === void 0 ? void 0 : _column$links.map(function (link) {
        if (typeof link === 'function') {
          link = link({
            config: config,
            auth: auth
          });
          if (!link) return null;
        }

        return h("li", {
          key: link.to || link.href,
          className: themeUtil(styles$8, 'listItem')
        }, h(Link$1, link));
      })));
    })));
  };

  return NavFooter;
}(Component), _class2$5.propTypes = {
  config: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  inverted: PropTypes.bool
}, _class2$5.defaultProps = {
  inverted: false
}, _temp$6)) || _class$8) || _class$8) || _class$8);
var styles$9 = {
  "section": "styles-module_section__3it4s",
  "content": "styles-module_content__3VDXY",
  "stretch": "styles-module_stretch__3Qte5",
  "title": "styles-module_title__Z9skz",
  "subtitle": "styles-module_subtitle__3U5mR",
  "desc": "styles-module_desc__2eFJn"
};

var _class$9, _class2$6, _temp$7;

var Section = observer(_class$9 = (_temp$7 = _class2$6 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Section, _Component);

  function Section() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Section.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inverted = _this$props.inverted,
        stretch = _this$props.stretch,
        title = _this$props.title,
        subtitle = _this$props.subtitle,
        desc = _this$props.desc,
        id = _this$props.id,
        className = _this$props.className,
        contentClassName = _this$props.contentClassName,
        _this$props$style = _this$props.style,
        style = _this$props$style === void 0 ? {} : _this$props$style,
        _this$props$contentSt = _this$props.contentStyle,
        contentStyle = _this$props$contentSt === void 0 ? {} : _this$props$contentSt,
        children = _this$props.children;
    var sectionProps = {};

    if (id || title) {
      sectionProps.id = id || slugify(title.toLowerCase());
    }

    var themeArgs = [styles$9, 'section', themeUtil(styles$9, sectionProps.id + "-section"), inverted && themeUtil(styles$9, 'inverted'), className];
    return h("section", _extends({
      className: themeUtil.apply(void 0, themeArgs),
      style: _extends({
        background: themeUtil['@section-bg'] ? inverted ? themeUtil['@section-fg-color'] : themeUtil['@section-bg-color'] : undefined
      }, style)
    }, sectionProps), h("div", {
      className: themeUtil(styles$9, 'content', stretch && themeUtil(styles$9, 'stretch'), contentClassName),
      style: contentStyle
    }, title && h("h1", {
      className: themeUtil(styles$9, 'title')
    }, title), subtitle && h("h5", {
      className: themeUtil(styles$9, 'subtitle')
    }, subtitle), desc && h("p", {
      className: themeUtil(styles$9, 'desc')
    }, desc), children));
  };

  return Section;
}(Component), _class2$6.propTypes = {
  inverted: PropTypes.bool,
  stretch: PropTypes.bool,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  desc: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  style: PropTypes.object,
  contentStyle: PropTypes.object,
  children: PropTypes.node
}, _class2$6.defaultProps = {
  inverted: false,
  stretch: false
}, _temp$7)) || _class$9;

var styles$a = {
  "dashboard": "styles-module_dashboard__1hS0Q"
};

var DashboardSection = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DashboardSection, _Component);

  function DashboardSection() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = DashboardSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        rest = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    return h(Section, _extends({
      id: "dashboard",
      title: "Dashboard",
      className: themeUtil(styles$a, 'dashboard', className)
    }, rest));
  };

  return DashboardSection;
}(Component);

var styles$b = {
  "body": "styles-module_body__284OX"
};

var _dec$7, _class$a, _class2$7, _temp$8;

var ProfileSection = (_dec$7 = inject('auth'), _dec$7(_class$a = observer(_class$a = (_temp$8 = _class2$7 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ProfileSection, _Component);

  function ProfileSection() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      copiedTextToClipboard: false,
      isLoadingUnsubscribe: false,
      isLoadingRefreshAuthToken: false
    };

    _this._onClickCopyToken = function () {
      var token = _this.props.auth.consumer.token;
      copyTextToClipboard(token);

      _this.setState({
        copiedTextToClipboard: true
      });

      _this._clearCopyTimeout();

      _this._copyTimeout = setTimeout(_this._onCopyTimeout, 3000);
    };

    _this._onCopyTimeout = function () {
      _this._clearCopyTimeout();

      _this.setState({
        copiedTextToClipboard: false
      });
    };

    _this._clearCopyTimeout = function () {
      if (_this._copyTimeout) {
        clearTimeout(_this._copyTimeout);
        _this._copyTimeout = null;
      }
    };

    _this._onConfirmUnsubscribe = function () {
      _this.setState({
        isLoadingUnsubscribe: true
      });

      API.removeConsumer(_this.props.auth.consumer).then(function () {
        _this.props.auth.consumer = null;
        notification.success({
          message: 'Subscription canceled',
          duration: 0,
          description: h("span", null, h("p", null, "Your subscription has been canceled. If you have any pending charges, they will be billed at the end of the current billing cycle."), h("p", null, "It may take a few minutes for this change to take effect."))
        });

        _this.setState({
          isLoadingUnsubscribe: false
        });
      }, function (err) {
        var _err$response, _err$response$data, _err$error;

        console.warn(err);
        notification.error({
          message: 'Error canceling subscription',
          description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || ((_err$error = err.error) === null || _err$error === void 0 ? void 0 : _err$error.message),
          duration: 0
        });

        _this.setState({
          isLoadingUnsubscribe: false
        });
      });
    };

    _this._onClickRefreshAuthToken = function () {
      _this.setState({
        isLoadingRefreshAuthToken: true
      });

      API.updateConsumer(_this.props.auth.consumer).then(function (consumer) {
        _this.props.auth.consumer = consumer;
        notification.success({
          message: 'Auth token refreshed',
          description: h("span", null, h("p", null, "Your auth token has been refreshed. Your old token is now invalid."), h("p", null, "It may take a few minutes for this change to take effect."))
        });

        _this.setState({
          isLoadingRefreshAuthToken: false
        });
      }, function (err) {
        var _err$response2, _err$response2$data, _err$error2;

        console.warn(err);
        notification.error({
          message: 'Error refreshing auth token',
          description: (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.error) || ((_err$error2 = err.error) === null || _err$error2 === void 0 ? void 0 : _err$error2.message),
          duration: 0
        });

        _this.setState({
          isLoadingRefreshAuthToken: false
        });
      });
    };

    return _this;
  }

  var _proto = ProfileSection.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._copyTimeout) {
      clearTimeout(this._copyTimeout);
      this._copyTimeout = null;
    }
  };

  _proto.render = function render() {
    var _this2 = this,
        _auth$consumer5;

    var _this$props = this.props,
        auth = _this$props.auth,
        rest = _objectWithoutPropertiesLoose(_this$props, ["auth"]);

    var _this$state = this.state,
        copiedTextToClipboard = _this$state.copiedTextToClipboard,
        isLoadingUnsubscribe = _this$state.isLoadingUnsubscribe,
        isLoadingRefreshAuthToken = _this$state.isLoadingRefreshAuthToken;
    var hasSubscription = auth.consumer && auth.consumer.enabled && auth.consumer.plan && auth.consumer.plan !== 'free';
    var columns = [{
      title: 'Avatar',
      dataIndex: 'image',
      render: function render(image) {
        return image ? h(Avatar, {
          src: image,
          className: themeUtil(styles$b, 'avatar')
        }) : h(Avatar, {
          icon: "user",
          className: themeUtil(styles$b, 'avatar')
        });
      }
    }, {
      title: 'Username',
      dataIndex: 'username'
    }, {
      title: 'Email',
      dataIndex: 'email'
    }, {
      title: 'Joined',
      dataIndex: 'joined',
      render: function render(date) {
        return format(new Date(date), 'MM/dd/yyyy');
      }
    }, {
      title: 'Subscription',
      dataIndex: 'subscription',
      render: function render(subscription) {
        return h(Link$2, {
          to: "/pricing"
        }, subscription);
      }
    }, {
      title: 'Auth Token',
      key: 'token',
      render: function render(token) {
        var _auth$consumer, _auth$consumer2;

        return ((_auth$consumer = auth.consumer) === null || _auth$consumer === void 0 ? void 0 : _auth$consumer.enabled) && ((_auth$consumer2 = auth.consumer) === null || _auth$consumer2 === void 0 ? void 0 : _auth$consumer2.token) && h(Tooltip, {
          placement: "top",
          title: copiedTextToClipboard ? 'Copied!' : 'Copy to clipboard'
        }, h(Button, {
          type: "primary",
          ghost: true,
          onClick: _this2._onClickCopyToken
        }, auth.consumer.token.substr(0, 8) + " ..."));
      }
    }, {
      title: 'Actions',
      key: 'actions',
      render: function render(token) {
        var _auth$consumer3, _auth$consumer4;

        return h(Fragment, null, ((_auth$consumer3 = auth.consumer) === null || _auth$consumer3 === void 0 ? void 0 : _auth$consumer3.enabled) && ((_auth$consumer4 = auth.consumer) === null || _auth$consumer4 === void 0 ? void 0 : _auth$consumer4.token) && h(Fragment, null, h(Button, {
          type: "ghost",
          icon: "reload",
          loading: isLoadingRefreshAuthToken,
          onClick: _this2._onClickRefreshAuthToken,
          block: true
        }, "Refresh Token"), h(Divider, {
          type: "horizontal",
          style: {
            marginTop: 8,
            marginBottom: 8
          }
        })), hasSubscription ? h(Popconfirm, {
          placement: "top",
          title: "Are you sure you want to cancel your subscription?",
          okText: "Yes",
          cancelText: "No",
          onConfirm: _this2._onConfirmUnsubscribe
        }, h(Button, {
          type: "default",
          loading: isLoadingUnsubscribe,
          block: true
        }, "Cancel")) : h(Button, {
          type: "primary",
          href: "/pricing",
          block: true
        }, "Upgrade"));
      }
    }].filter(Boolean);
    var dataSource = [{
      id: auth.user.id,
      username: auth.user.username,
      email: auth.user.email,
      image: auth.user.image,
      joined: auth.user.createdAt,
      subscription: hasSubscription ? auth.consumer.plan : auth.consumer && auth.consumer.enabled && auth.consumer.plan ? auth.consumer.plan : 'none',
      subscribed: (_auth$consumer5 = auth.consumer) === null || _auth$consumer5 === void 0 ? void 0 : _auth$consumer5.createdAt
    }];
    return h(Section, _extends({
      id: "profile",
      title: "Profile"
    }, rest), h("div", {
      className: themeUtil(styles$b, 'body')
    }, h(Table, {
      columns: columns,
      rowKey: function rowKey(record) {
        return record.id;
      },
      dataSource: dataSource,
      pagination: false
    })));
  };

  return ProfileSection;
}(Component), _class2$7.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$8)) || _class$a) || _class$a);
var styles$c = {
  "body": "styles-module_body__2yNe4"
};

var _dec$8, _class$b, _class2$8, _temp$9;

var statusColors = {
  draft: 'geekblue',
  open: 'red',
  paid: 'green',
  uncollectable: 'volcano',
  "void": 'purple'
};
var columns = [{
  title: 'ID',
  dataIndex: 'number'
}, {
  title: 'Date',
  dataIndex: 'created',
  render: function render(timestamp) {
    return format(new Date(timestamp * 1000), 'MM/dd/yyyy');
  }
}, {
  title: 'Amount',
  dataIndex: 'amount_due',
  render: function render(amount) {
    return "$" + (amount / 100).toFixed(2);
  }
}, {
  title: 'Status',
  dataIndex: 'status',
  render: function render(status) {
    var color = statusColors[status];
    return h(Tag, {
      color: color
    }, titleize(status));
  }
}, {
  title: 'PDF',
  dataIndex: 'invoice_pdf',
  render: function render(link) {
    return h("a", {
      href: link,
      title: "Invoice PDF",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Download");
  }
}];
var InvoicingSection = (_dec$8 = inject('auth'), _dec$8(_class$b = observer(_class$b = (_temp$9 = _class2$8 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InvoicingSection, _Component);

  function InvoicingSection() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      data: [],
      pagination: {
        pageSize: 10
      },
      loading: false
    };
    _this._disposer = reaction(function () {
      return _this.props.auth.consumer;
    }, function () {
      return _this._fetch({
        reset: true
      });
    });

    _this._handleTableChange = function (pagination, filters, sorter) {
      var pager = _extends({}, _this.state.pagination);

      pager.current = pagination.current;

      _this.setState({
        pagination: pager
      });

      _this._fetch(_extends({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order
      }, filters));
    };

    _this._fetch = function (params) {
      if (params === void 0) {
        params = {};
      }

      var auth = _this.props.auth;

      if (!auth.consumer) {
        return;
      }

      var _this$state = _this.state,
          data = _this$state.data,
          pagination = _this$state.pagination;

      if (params.reset) {
        data = [];
        params.page = 0;
      }

      if (!params.page || params.page * pagination.pageSize >= data.length) {
        _this.setState({
          loading: true
        });

        var opts = {
          limit: 10
        };

        if (data.length) {
          opts.ending_before = data[data.length - 1].id;
        }

        API.listBillingInvoicesForConsumer(auth.consumer, opts).then(function (invoices) {
          var pagination = _extends({}, _this.state.pagination);

          if (!invoices.length) {
            pagination.total = data.length;
          } else {
            data = data.concat(invoices);
            pagination.total = data.length;
          }

          _this.setState({
            loading: false,
            data: data,
            pagination: pagination
          });
        });
      }
    };

    return _this;
  }

  var _proto = InvoicingSection.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._fetch();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._disposer();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        rest = _objectWithoutPropertiesLoose(_this$props, ["auth"]);

    var _this$state2 = this.state,
        data = _this$state2.data,
        pagination = _this$state2.pagination,
        loading = _this$state2.loading;
    return h(Section, _extends({
      id: "invoicing",
      title: "Invoicing"
    }, rest), h("div", {
      className: themeUtil(styles$c, 'body')
    }, h(Table, {
      columns: columns,
      rowKey: function rowKey(record) {
        return record.id;
      },
      dataSource: data,
      pagination: pagination,
      loading: loading,
      onChange: this._handleTableChange
    })));
  };

  return InvoicingSection;
}(Component), _class2$8.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$9)) || _class$b) || _class$b);

var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var styles$d = {
  "body": "styles-module_body__3rg-g",
  "addSourceButton": "styles-module_addSourceButton__2-ZeC"
};

var _dec$9, _class$c, _class2$9, _temp$a;

var BillingSourcesSection = (_dec$9 = inject('auth'), _dec$9(_class$c = observer(_class$c = (_temp$a = _class2$9 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BillingSourcesSection, _Component);

  function BillingSourcesSection() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      data: [],
      hasMoreData: true,
      isLoading: false,
      isVisibleAddNewSourceModal: false,
      isVisibleRemoveSourceModal: false,
      isVisibleSetDefaultSourceModal: false,
      isLoadingAddNewSourceModal: false,
      isLoadingRemoveSourceModal: false,
      isLoadingSetDefaultSourceModal: false,
      selectedSource: null
    };
    _this._columns = [{
      title: 'Brand',
      dataIndex: 'brand'
    }, {
      title: 'Number',
      dataIndex: 'last4',
      render: function render(last4) {
        return "XXXX - " + last4;
      }
    }, {
      title: 'Name',
      dataIndex: 'name'
    }, {
      title: 'Expiration',
      key: 'expiration',
      render: function render(card) {
        return card.exp_month + " / " + card.exp_year;
      }
    }, {
      title: 'Zipcode',
      dataIndex: 'address_zip'
    }, {
      title: 'Default',
      dataIndex: 'default',
      render: function render(isDefault) {
        return isDefault ? h(Icon, {
          type: "check-circle",
          theme: "twoTone",
          twoToneColor: "#52c41a",
          style: {
            fontSize: '1.8em'
          }
        }) : '';
      }
    }, {
      title: 'Actions',
      key: 'actions',
      render: function render(card) {
        return h(Fragment, null, h(Tooltip, {
          title: card["default"] ? 'Unable to remove default card' : undefined
        }, h(Button, {
          type: "link",
          disabled: card["default"],
          onClick: function onClick() {
            return _this._onClickRemoveSourceButton(card);
          }
        }, "Remove")), h(Divider, {
          type: "vertical"
        }), h(Tooltip, {
          title: card["default"] ? 'This card is already the default' : undefined
        }, h(Button, {
          type: "link",
          disabled: card["default"],
          onClick: function onClick() {
            return _this._onClickSetDefaultSourceButton(card);
          }
        }, "Set Default")));
      }
    }];
    _this._disposer = reaction(function () {
      return _this.props.auth.user;
    }, function () {
      return _this._fetch();
    });

    _this._handleTableChange = function (pagination, filters, sorter) {
      _this._fetch(_extends({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order
      }, filters));
    };

    _this._fetch = function (params) {
      var auth = _this.props.auth;

      if (!auth.user) {
        return;
      }

      var _this$state = _this.state,
          data = _this$state.data,
          hasMoreData = _this$state.hasMoreData;

      if (!data.length && hasMoreData) {
        _this.setState({
          isLoading: true
        });

        API.listBillingSources().then(function (sources) {
          if (!sources.length) {
            hasMoreData = false;
          } else {
            sources.sort(function (a, b) {
              return a.id.localeCompare(b.id);
            });
            data = data.concat(sources);
          }

          _this.setState({
            isLoading: false,
            data: data,
            hasMoreData: hasMoreData
          });
        }, function (err) {
          console.warn(err);

          _this.setState({
            isLoading: false
          });
        });
      }
    };

    _this._onClickAddNewSourceButton = function () {
      _this.setState({
        isVisibleAddNewSourceModal: true
      });
    };

    _this._onConfirmNewSourceModal = function (_ref) {
      var name = _ref.name,
          stripe = _ref.stripe;

      try {
        _this.setState({
          isLoadingAddNewSourceModal: true
        });

        return Promise.resolve(_catch(function () {
          return Promise.resolve(stripe.createToken({
            name: name
          })).then(function (_ref2) {
            var token = _ref2.token,
                error = _ref2.error;
            console.log({
              token: token,
              error: error
            });

            if (error) {
              notification.error({
                message: 'Error processing payment method',
                description: error.message,
                duration: 0
              });

              _this.setState({
                isLoadingAddNewSourceModal: false
              });

              return;
            }

            return Promise.resolve(API.addBillingSource({
              source: token.id
            })).then(function (source) {
              console.log('checkout source', {
                source: source
              });

              _this.setState({
                data: [],
                hasMoreData: true,
                isLoadingAddNewSourceModal: false,
                isVisibleAddNewSourceModal: false
              }, function () {
                notification.success({
                  message: 'Payment Method Added',
                  description: "Your " + source.brand + " card ending in " + source.last4 + " was added successfully."
                });

                _this._fetch();
              });
            });
          });
        }, function (err) {
          notification.error({
            message: 'Error adding payment source',
            description: err.error && err.error.message,
            duration: 0
          });

          _this.setState({
            isLoadingAddNewSourceModal: false
          });
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this._onCancelNewSourceModal = function () {
      _this.setState({
        isVisibleAddNewSourceModal: false
      });
    };

    _this._onClickRemoveSourceButton = function (selectedSource) {
      _this.setState({
        isVisibleRemoveSourceModal: true,
        selectedSource: selectedSource
      });
    };

    _this._onConfirmRemoveSourceModal = function () {
      var selectedSource = _this.state.selectedSource;

      _this.setState({
        isLoadingRemoveSourceModal: true
      });

      API.removeBillingSource(selectedSource.id).then(function () {
        _this.setState({
          data: [],
          hasMoreData: true,
          isLoadingRemoveSourceModal: false,
          isVisibleRemoveSourceModal: false,
          selectedSource: null
        }, function () {
          notification.success({
            message: 'Card Removed',
            description: "Your " + selectedSource.brand + " card ending in " + selectedSource.last4 + " has been removed."
          });

          _this._fetch();
        });
      }, function (err) {
        console.warn(err);

        _this.setState({
          isLoadingRemoveSourceModal: false
        });

        notification.error({
          message: 'Error',
          description: "There was an error trying to remove your " + selectedSource.brand + " card ending in " + selectedSource.last4 + ".",
          duration: 10
        });
      });
    };

    _this._onCancelRemoveSourceModal = function () {
      _this.setState({
        isVisibleRemoveSourceModal: false,
        selectedSource: null
      });
    };

    _this._onClickSetDefaultSourceButton = function (selectedSource) {
      _this.setState({
        isVisibleSetDefaultSourceModal: true,
        selectedSource: selectedSource
      });
    };

    _this._onConfirmSetDefaultSourceModal = function () {
      var selectedSource = _this.state.selectedSource;

      _this.setState({
        isLoadingSetDefaultSourceModal: true
      });

      API.setDefaultBillingSource(selectedSource.id).then(function () {
        _this.setState({
          data: [],
          hasMoreData: true,
          isLoadingSetDefaultSourceModal: false,
          isVisibleSetDefaultSourceModal: false,
          selectedSource: null
        }, function () {
          notification.success({
            message: 'Card Set as Default',
            description: "Your " + selectedSource.brand + " card ending in " + selectedSource.last4 + " has been set as your default payment method."
          });

          _this._fetch();
        });
      }, function (err) {
        console.warn(err);

        _this.setState({
          isLoadingRemoveSourceModal: false
        });

        notification.error({
          message: 'Error',
          description: "There was an error trying to set the " + selectedSource.brand + " card ending in " + selectedSource.last4 + " as your default payment method.",
          duration: 10
        });
      });
    };

    _this._onCancelSetDefaultSourceModal = function () {
      _this.setState({
        isVisibleSetDefaultSourceModal: false,
        selectedSource: null
      });
    };

    return _this;
  }

  var _proto = BillingSourcesSection.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._fetch();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._disposer();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        rest = _objectWithoutPropertiesLoose(_this$props, ["auth"]);

    var _this$state2 = this.state,
        data = _this$state2.data,
        isLoading = _this$state2.isLoading,
        isVisibleAddNewSourceModal = _this$state2.isVisibleAddNewSourceModal,
        isVisibleRemoveSourceModal = _this$state2.isVisibleRemoveSourceModal,
        isVisibleSetDefaultSourceModal = _this$state2.isVisibleSetDefaultSourceModal,
        isLoadingAddNewSourceModal = _this$state2.isLoadingAddNewSourceModal,
        isLoadingRemoveSourceModal = _this$state2.isLoadingRemoveSourceModal,
        isLoadingSetDefaultSourceModal = _this$state2.isLoadingSetDefaultSourceModal,
        selectedSource = _this$state2.selectedSource;
    return h(Section, _extends({
      id: "billing-sources",
      title: "Payment Methods"
    }, rest), h("div", {
      className: themeUtil(styles$d, 'body')
    }, h(Table, {
      columns: this._columns,
      rowKey: function rowKey(record) {
        return record.id;
      },
      dataSource: data,
      pagination: false,
      loading: isLoading,
      onChange: this._handleTableChange
    }), h(Button, {
      type: "primary",
      className: themeUtil(styles$d, 'addSourceButton'),
      onClick: this._onClickAddNewSourceButton
    }, "Add New Payment Method")), h(Modal, {
      title: "Add New Payment Method",
      visible: isVisibleAddNewSourceModal,
      okButtonProps: {
        disabled: true
      },
      confirmLoading: isLoadingAddNewSourceModal,
      onCancel: this._onCancelNewSourceModal
    }, isVisibleAddNewSourceModal && h(CheckoutForm, {
      action: "Add Card",
      loading: isLoadingAddNewSourceModal,
      onSubmit: this._onConfirmNewSourceModal
    })), h(Modal, {
      title: "Remove Payment Method",
      visible: isVisibleRemoveSourceModal,
      onOk: this._onConfirmRemoveSourceModal,
      confirmLoading: isLoadingRemoveSourceModal,
      onCancel: this._onCancelRemoveSourceModal
    }, selectedSource && h("div", null, "Are you sure you want to remove the ", selectedSource.brand, " card ending in ", h("b", null, selectedSource.last4), " from your payment methods?")), h(Modal, {
      title: "Set Default Payment Method",
      visible: isVisibleSetDefaultSourceModal,
      onOk: this._onConfirmSetDefaultSourceModal,
      confirmLoading: isLoadingSetDefaultSourceModal,
      onCancel: this._onCancelSetDefaultSourceModal
    }, selectedSource && h("div", null, "Are you sure you want to set the ", selectedSource.brand, " card ending in ", h("b", null, selectedSource.last4), " as your default payment method?")));
  };

  return BillingSourcesSection;
}(Component), _class2$9.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$a)) || _class$c) || _class$c);
var styles$e = {
  "body": "styles-module_body__12yY2"
};

var _dec$a, _dec2$4, _class$d, _class2$a, _temp$b;

var BillingUsageSection = (_dec$a = inject('auth'), _dec2$4 = inject('config'), _dec$a(_class$d = _dec2$4(_class$d = observer(_class$d = (_temp$b = _class2$a = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BillingUsageSection, _Component);

  function BillingUsageSection() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      data: [],
      pagination: {
        pageSize: 10
      },
      loading: false
    };
    _this.metrics = _this.props.config.deployment.pricingPlans.reduce(function (acc, plan) {
      return _extends({}, acc, {}, plan.metrics.reduce(function (acc, metric) {
        var _extends2;

        return _extends({}, acc, (_extends2 = {}, _extends2[metric.slug] = metric, _extends2));
      }, {}));
    }, {});
    _this.columns = [{
      title: 'Start',
      dataIndex: 'request.period.start',
      render: function render(timestamp) {
        return timestamp ? format(new Date(timestamp * 1000), 'MM/dd/yyyy') : '';
      }
    }, {
      title: 'End',
      dataIndex: 'request.period.end',
      render: function render(timestamp) {
        return timestamp ? format(new Date(timestamp * 1000), 'MM/dd/yyyy') : 'Current';
      }
    }, {
      title: 'Total Requests',
      dataIndex: 'request.total_usage'
    }].concat(Object.keys(_this.metrics).map(function (metricSlug) {
      var metric = _this.metrics[metricSlug];
      return {
        title: "Total " + metric.label,
        dataIndex: metricSlug + ".total_usage",
        render: function render(amount) {
          return h("b", null, amount || 0);
        }
      };
    }));
    _this._disposer = reaction(function () {
      return _this.props.auth.consumer;
    }, function () {
      return _this._fetch({
        reset: true
      });
    });

    _this._handleTableChange = function (pagination, filters, sorter) {
      var pager = _extends({}, _this.state.pagination);

      pager.current = pagination.current;

      _this.setState({
        pagination: pager
      });

      _this._fetch(_extends({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order
      }, filters));
    };

    _this._fetch = function (params) {
      if (params === void 0) {
        params = {};
      }

      var auth = _this.props.auth;

      if (!auth.consumer) {
        return;
      }

      var _this$state = _this.state,
          data = _this$state.data,
          pagination = _this$state.pagination;

      if (params.reset) {
        data = [];
        params.page = 0;
      }

      if (!params.page || params.page * pagination.pageSize >= data.length) {
        _this.setState({
          loading: true
        });

        var opts = {
          limit: 10
        };

        if (data.length) {
          opts.ending_before = data[data.length - 1].id;
        }

        API.listBillingUsageForConsumer(auth.consumer, opts).then(function (items) {
          var pagination = _extends({}, _this.state.pagination);

          if (!items.length) {
            pagination.total = data.length;
          } else {
            data = data.concat(items);
            pagination.total = data.length;
          }

          _this.setState({
            loading: false,
            data: data,
            pagination: pagination
          });
        });
      }
    };

    return _this;
  }

  var _proto = BillingUsageSection.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._fetch();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._disposer();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        rest = _objectWithoutPropertiesLoose(_this$props, ["auth", "config"]);

    var _this$state2 = this.state,
        data = _this$state2.data,
        pagination = _this$state2.pagination,
        loading = _this$state2.loading;
    return h(Section, _extends({
      id: "billing-usage",
      title: "Usage"
    }, rest), h("div", {
      className: themeUtil(styles$e, 'body')
    }, h(Table, {
      columns: this.columns,
      rowKey: function rowKey(record) {
        return record.request.id;
      },
      dataSource: data,
      pagination: pagination,
      loading: loading,
      onChange: this._handleTableChange
    })));
  };

  return BillingUsageSection;
}(Component), _class2$a.propTypes = {
  auth: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired
}, _temp$b)) || _class$d) || _class$d) || _class$d);

var UndrawSVG = /*#__PURE__*/function (_Component) {
  _inheritsLoose(UndrawSVG, _Component);

  function UndrawSVG() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = UndrawSVG.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["className", "name", "color"]);

    var uri = name.includes('/') || name.includes('.') ? name : "/assets/undraw/" + name + ".svg";
    return h("img", _extends({
      src: uri,
      alt: name,
      className: themeUtil(null, 'undrawSVG', className)
    }, rest));
  };

  return UndrawSVG;
}(Component);

UndrawSVG.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
};
var styles$f = {
  "illustration": "styles-module_illustration__187w3"
};

var NotFoundSection = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NotFoundSection, _Component);

  function NotFoundSection() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = NotFoundSection.prototype;

  _proto.render = function render() {
    var subtitle = h("span", null, "Uh-oh, it looks like the page you're looking for doesn't exist.");
    return h(Section, _extends({
      id: "not-found",
      title: "Page Not Found",
      subtitle: subtitle
    }, this.props), h(UndrawSVG, {
      name: "page_not_found",
      className: themeUtil(styles$f, 'illustration')
    }));
  };

  return NotFoundSection;
}(Component);

var BlankSection = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BlankSection, _Component);

  function BlankSection() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BlankSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        style = _this$props.style,
        rest = _objectWithoutPropertiesLoose(_this$props, ["style"]);

    return h(Section, _extends({
      id: "blank",
      style: _extends({
        minHeight: '8em'
      }, style)
    }, rest));
  };

  return BlankSection;
}(Component);

var _dec$b, _class$e, _class2$b, _temp$c;

var isServer$1 = typeof window === 'undefined';
var V = 0.025;
var SectionDivider = (_dec$b = sizeMe({
  monitorWidth: true,
  monitorHeight: true
}), _dec$b(_class$e = observer(_class$e = (_temp$c = _class2$b = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SectionDivider, _Component);

  function SectionDivider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this._state = {
      dx0: random["float"](-V, V),
      dy0: random["float"](-V, V),
      dx1: random["float"](-V, V),
      dy1: random["float"](-V, V),
      x0: random["float"](0.0, 0.4),
      y0: random["float"](0.2, 1.0),
      x1: random["float"](0.4, 1.0),
      y1: random["float"](0.5, 1.0),
      ltr: random["boolean"]()
    };

    _this._containerRef = function (ref) {
      _this._container = ref;
    };

    _this._canvasRef = function (ref) {
      _this._canvas = ref;
    };

    _this._onResize = function () {
      _this._canvas.width = _this._container.clientWidth;
      _this._canvas.height = _this._container.clientHeight;

      _this._draw();
    };

    _this._tick = function () {
      _this._draw();

      if (_this.props.animated) {
        _this._update();

        _this._tickRaf = raf(_this._tick);
      }
    };

    _this._disposer = autorun(function () {
      return _this._draw();
    });
    return _this;
  }

  var _proto = SectionDivider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!isServer$1) {
      window.addEventListener('resize', this._onResize);

      this._reset(this.props);

      this._tick();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (!isServer$1) {
      window.removeEventListener('resize', this._onResize);

      if (this._tickRaf) {
        raf.cancel(this._tickRaf);
        this._tickRaf = null;
      }
    }

    this._disposer();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        style = _this$props.style,
        className = _this$props.className,
        rest = _objectWithoutPropertiesLoose(_this$props, ["inverted", "animated", "style", "className"]);

    return h("div", _extends({
      style: _extends({
        width: '100%',
        height: 64
      }, style),
      className: themeUtil(null, 'section-divider', className)
    }, rest, {
      ref: this._containerRef
    }), h("canvas", {
      ref: this._canvasRef,
      style: {
        width: '100%',
        height: '101%'
      }
    }));
  };

  _proto._update = function _update() {
    var _this$_state = this._state,
        dx0 = _this$_state.dx0,
        dy0 = _this$_state.dy0,
        dx1 = _this$_state.dx1,
        dy1 = _this$_state.dy1,
        x0 = _this$_state.x0,
        y0 = _this$_state.y0,
        x1 = _this$_state.x1,
        y1 = _this$_state.y1;
    dx0 = Math.max(-V, Math.min(V, dx0 + random["float"](-V / 10, V / 10)));
    dy0 = Math.max(-V, Math.min(V, dy0 + random["float"](-V / 10, V / 10)));
    dx1 = Math.max(-V, Math.min(V, dx1 + random["float"](-V / 10, V / 10)));
    dy1 = Math.max(-V, Math.min(V, dy1 + random["float"](-V / 10, V / 10)));
    x0 = Math.max(0.0, Math.min(0.4, x0 + dx0));
    y0 = Math.max(0.2, Math.min(1.0, y0 + dy0));
    x1 = Math.max(0.4, Math.min(1.0, x1 + dx1));
    y1 = Math.max(0.5, Math.min(1.0, y1 + dy1));
    this._state = {
      dx0: dx0,
      dy0: dy0,
      dx1: dx1,
      dy1: dy1,
      x0: x0,
      y0: y0,
      x1: x1,
      y1: y1
    };
  };

  _proto._draw = function _draw() {
    var inverted = this.props.inverted;
    var _this$_state2 = this._state,
        x0 = _this$_state2.x0,
        y0 = _this$_state2.y0,
        x1 = _this$_state2.x1,
        y1 = _this$_state2.y1,
        ltr = _this$_state2.ltr;
    var foreground = themeUtil['@section-fg-color'];
    var background = themeUtil['@section-bg-color'];

    if (!this._canvas) {
      return;
    }

    var fg = Colr.fromHex(foreground).toRgbArray();
    var foregroundLight = "rgba(" + fg[0] + ", " + fg[1] + ", " + fg[2] + ", 0.5)";

    var ctx = this._canvas.getContext('2d');

    var w = this._canvas.width;
    var h = this._canvas.height;
    ctx.fillStyle = background;
    ctx.fillRect(0, 0, w, h);

    if (ltr) {
      ctx.fillStyle = foregroundLight;
      ctx.beginPath();
      ctx.moveTo(0, inverted ? h : 0);

      var _cx = w * x0;

      var _cy = h * y0;

      var _cx2 = w * x1;

      var _cy2 = h * y1;

      ctx.bezierCurveTo(_cx, inverted ? h - _cy : _cy, _cx2, inverted ? h - _cy2 : _cy2, w, h / 2);
      ctx.lineTo(w, inverted ? h : 0);
      ctx.fill();
    } else {
      ctx.fillStyle = foregroundLight;
      ctx.beginPath();
      ctx.moveTo(w, inverted ? h : 0);

      var _cx3 = w * x0;

      var _cy3 = h * y0;

      var _cx4 = w * x1;

      var _cy4 = h * y1;

      ctx.bezierCurveTo(_cx4, inverted ? h - _cy3 : _cy3, _cx3, inverted ? h - _cy4 : _cy4, 0, h / 2);
      ctx.lineTo(0, inverted ? h : 0);
      ctx.fill();
    }

    ctx.fillStyle = foreground;
    ctx.beginPath();
    ctx.moveTo(0, inverted ? h : 0);
    var cx0 = w * x0;
    var cy0 = h * y0;
    var cx1 = w * x1;
    var cy1 = h * y1;
    ctx.bezierCurveTo(cx0, inverted ? h - cy0 : cy0, cx1, inverted ? h - cy1 : cy1, w, inverted ? h : 0);
    ctx.fill();
  };

  _proto._reset = function _reset(props) {
    this._onResize();
  };

  return SectionDivider;
}(Component), _class2$b.propTypes = {
  inverted: PropTypes.bool,
  animated: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  })
}, _class2$b.defaultProps = {
  inverted: false,
  animated: false,
  style: {}
}, _temp$c)) || _class$e) || _class$e);
SyntaxHighlighter.registerLanguage('js', js);
SyntaxHighlighter.registerLanguage('json', json);
SyntaxHighlighter.registerLanguage('python', python);
SyntaxHighlighter.registerLanguage('ruby', ruby);
SyntaxHighlighter.registerLanguage('bash', bash);
var styles$g = {
  "code-block": "styles-module_code-block__paur2"
};

var CodeBlock = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CodeBlock, _Component);

  function CodeBlock() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = CodeBlock.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        language = _this$props.language,
        value = _this$props.value,
        className = _this$props.className;
    var _theme$codeTheme = themeUtil.codeTheme,
        codeTheme = _theme$codeTheme === void 0 ? defaultCodeTheme : _theme$codeTheme;
    return h(SyntaxHighlighter, {
      className: themeUtil(styles$g, 'code-block', className),
      language: language,
      style: codeTheme
    }, value);
  };

  return CodeBlock;
}(Component);

CodeBlock.propTypes = {
  language: PropTypes.string,
  value: PropTypes.string.isRequired,
  className: PropTypes.string
};

var ImageZoom = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ImageZoom, _Component);

  function ImageZoom() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this._zoom = _this.props.zoom.clone();

    _this._attachZoom = function (image) {
      _this._zoom.attach(image);
    };

    return _this;
  }

  var _proto = ImageZoom.prototype;

  _proto.render = function render() {
    return h("img", {
      src: this.props.src,
      alt: this.props.alt,
      ref: this._attachZoom
    });
  };

  return ImageZoom;
}(Component);

var mapProp = function mapProp(prop, onChange) {
  if (prop && prop !== onChange && prop.type) {
    var type = prop.type,
        props = _objectWithoutPropertiesLoose(prop, ["type"]);

    return {
      type: props["enum"] ? 'enum' : type,
      props: _extends({}, props, {
        onChange: onChange,
        name: props.propKey
      })
    };
  }

  return prop;
};

var ReactFromJSONSchema = function ReactFromJSONSchema(_ref) {
  var definition = _ref.definition,
      mapping = _ref.mapping,
      onChange = _ref.onChange;
  var memMapProp = useCallback(function (prop) {
    return mapProp(prop, onChange);
  }, []);
  return h(ReactFromJSON, {
    entry: _extends({}, definition.params.schema.properties, {
      type: 'entry'
    }),
    mapping: mapping,
    mapProp: memMapProp
  });
};

var ServiceEntry = function ServiceEntry(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, ["propKey", "_type", "onChange"]);

  return h(React.Fragment, null, Object.values(props));
};

var styles$h = {
  "service-form__input-wrapper": "styles-module_service-form__input-wrapper__3g7Ot",
  "service-form__input-label": "styles-module_service-form__input-label__3qi73",
  "service-form__input-name": "styles-module_service-form__input-name__3gtgx",
  "service-form": "styles-module_service-form__1g3V7"
};

var ServiceInputWrapper = function ServiceInputWrapper(_ref) {
  var children = _ref.children;
  return h("div", {
    className: themeUtil(styles$h, 'service-form__input-wrapper')
  }, children);
};

var allowedTypes = ['strong', 'emphasis', 'link', 'text'];

var ServiceInputWrapperWithLabel = function ServiceInputWrapperWithLabel(_ref) {
  var _desc;

  var children = _ref.children,
      propKey = _ref.propKey,
      description = _ref.description;
  var desc = (description === null || description === void 0 ? void 0 : description.length) > 80 ? description.split('\n')[0] : description;

  if (((_desc = desc) === null || _desc === void 0 ? void 0 : _desc.length) > 80) {
    desc = desc.split('.')[0];
  }

  return h(ServiceInputWrapper, null, h("label", null, h("div", {
    className: themeUtil(styles$h, 'service-form__input-label')
  }, h("span", {
    className: themeUtil(styles$h, 'service-form__input-name')
  }, propKey, desc && ' - '), desc && h("span", {
    className: themeUtil(styles$h, 'service-form__input-description')
  }, h(ReactMarkdown, {
    source: desc,
    allowedTypes: allowedTypes,
    escapeHtml: false,
    linkTarget: "_blank",
    unwrapDisallowed: true
  }))), children));
};

var ServiceInput = function ServiceInput(_ref) {
  var defaultValue = _ref["default"],
      type = _ref.type,
      onChange = _ref.onChange,
      propKey = _ref.propKey,
      props = _objectWithoutPropertiesLoose(_ref, ["default", "type", "onChange", "propKey"]);

  return h(ServiceInputWrapperWithLabel, _extends({
    propKey: propKey
  }, props), h(Input, {
    type: type,
    value: defaultValue,
    onChange: onChange,
    name: propKey
  }));
};

var ServiceInputCheckbox = function ServiceInputCheckbox(_ref) {
  var defaultValue = _ref["default"],
      type = _ref.type,
      propKey = _ref.propKey,
      onChange = _ref.onChange,
      name = _ref.name;
  return h(ServiceInputWrapper, null, h(Checkbox, {
    type: type,
    checked: defaultValue,
    onChange: onChange,
    name: name
  }, propKey));
};

var ServiceInputJSON = function ServiceInputJSON(_ref) {
  var defaultValue = _ref["default"],
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["default", "type", "onChange", "name"]);

  var _useState = useState(function () {
    return prettier.format(JSON.stringify(defaultValue), {
      parser: 'json',
      plugins: [prettierBabylon]
    });
  }),
      value = _useState[0],
      setValue = _useState[1];

  var onValueChange = useCallback(function (value) {
    setValue(value);

    try {
      onChange({
        target: {
          name: props.propKey,
          value: JSON.parse(value)
        }
      });
    } catch (_unused) {}
  }, []);
  var highlight = useCallback(function (code) {
    return h(SyntaxHighlighter, {
      language: "json",
      style: codeTheme
    }, code);
  }, []);
  return h(ServiceInputWrapperWithLabel, props, h(Editor, {
    value: value,
    onValueChange: onValueChange,
    highlight: highlight,
    useInlineStyles: false,
    style: {
      background: 'rgb(30, 30, 30)',
      borderRadius: 4,
      outline: 'none !important',
      zIndex: 10
    }
  }));
};

var ServiceInputNumber = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ServiceInputNumber, _React$Component);

  function ServiceInputNumber() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this._onChange = function (value) {
      _this.props.onChange({
        target: {
          name: _this.props.name || _this.props.propKey,
          value: value
        }
      });
    };

    return _this;
  }

  var _proto = ServiceInputNumber.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        defaultValue = _this$props["default"],
        name = _this$props.name,
        props = _objectWithoutPropertiesLoose(_this$props, ["default", "onChange", "name"]);

    return h(ServiceInputWrapperWithLabel, props, h(InputNumber, {
      value: defaultValue,
      onChange: this._onChange,
      name: name
    }));
  };

  return ServiceInputNumber;
}(React.Component);

var style = {
  width: '100%'
};

var ServiceInputSelect = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ServiceInputSelect, _Component);

  function ServiceInputSelect() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      items: []
    };

    _this._onChange = function (value) {
      _this.props.onChange({
        target: {
          value: value,
          name: _this.props.propKey
        }
      });
    };

    _this._onSearch = function (value) {
      var results = _this._fuse.search(value).slice(0, 32);

      _this.setState({
        items: results
      });
    };

    return _this;
  }

  var _proto = ServiceInputSelect.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var props = this.props;
    var docs = props["enum"].map(function (item) {
      return {
        n: item
      };
    });
    this._fuse = new Fuse(docs, {
      keys: ['n'],
      location: 7,
      threshold: 0.2,
      shouldSort: true
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        defaultValue = _this$props["default"],
        props = _objectWithoutPropertiesLoose(_this$props, ["default", "onChange", "enum"]);

    var items = this.state.items;
    var children = items.map(function (item) {
      return h(AutoComplete.Option, {
        key: item.n
      }, item.n);
    });
    return h(ServiceInputWrapperWithLabel, props, h(AutoComplete, {
      defaultValue: defaultValue,
      style: style,
      onChange: this._onChange,
      onSelect: this._onChange,
      onSearch: this._onSearch,
      placeholder: "Select"
    }, children));
  };

  return ServiceInputSelect;
}(Component);

var style$1 = {
  width: '100%'
};

var ServiceInputMultiSelect = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ServiceInputMultiSelect, _Component);

  function ServiceInputMultiSelect() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this._values = _this.props["default"];

    _this._onSelect = function (value) {
      _this._values.push(value);

      console.log('select', {
        value: value,
        values: _this._values
      });

      _this.props.onChange({
        target: {
          value: _this._values,
          name: _this.props.propKey
        }
      });
    };

    _this._onDeselect = function (value) {
      _this._values = _this._values.filter(function (v) {
        return v !== value;
      });
      console.log('deselect', {
        value: value,
        values: _this._values
      });

      _this.props.onChange({
        target: {
          value: _this._values,
          name: _this.props.propKey
        }
      });
    };

    return _this;
  }

  var _proto = ServiceInputMultiSelect.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        defaultValue = _this$props["default"],
        props = _objectWithoutPropertiesLoose(_this$props, ["default", "onChange"]);

    var items = this.props.items;
    var enums = items && items.props && items.props["enum"];

    if (!enums) {
      return h(ServiceInputJSON, this.props);
    }

    var children = enums.map(function (item) {
      return h(Select.Option, {
        key: item
      }, item);
    });
    return h(ServiceInputWrapperWithLabel, props, h(Select, {
      defaultValue: defaultValue,
      style: style$1,
      onSelect: this._onSelect,
      onDeselect: this._onDeselect,
      mode: "multiple",
      placeholder: "Select"
    }, children));
  };

  return ServiceInputMultiSelect;
}(Component);

var restrictDefinitionToExample = function restrictDefinitionToExample(definition, example, values) {
  return _extends({}, definition, {
    params: {
      schema: {
        properties: Object.keys(example.input).reduce(function (acc, key) {
          var _extends2;

          return _extends({}, acc, (_extends2 = {}, _extends2[key] = _extends({
            type: typeof example.input[key]
          }, definition.params.schema.properties[key], {
            "default": typeof values[key] !== 'undefined' ? values[key] : example.input[key]
          }), _extends2));
        }, {})
      }
    }
  });
};

var mergeInValues = function mergeInValues(definition, values) {
  var properties = definition.params.schema.properties;
  return _extends({}, definition, {
    params: {
      schema: {
        properties: Object.keys(properties).reduce(function (acc, key) {
          var _extends3;

          return _extends({}, acc, (_extends3 = {}, _extends3[key] = _extends({}, properties[key], {
            "default": values[key]
          }), _extends3));
        }, {})
      }
    }
  });
};

var ServiceForm = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ServiceForm, _Component);

  function ServiceForm() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      definition: {},
      values: {}
    };

    _this._handleOnChange = function (e) {
      var _extends2;

      var values = _extends({}, _this.state.values, (_extends2 = {}, _extends2[e.target.name] = e.target.value, _extends2));

      _this.setState({
        values: values
      });

      _this.props.onChange(values);
    };

    return _this;
  }

  ServiceForm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var definition = props.restrictToFirstExample ? restrictDefinitionToExample(props.service.definition, props.service.examples[0], state.values) : mergeInValues(props.service.definition);
    return _extends({}, state, {
      definition: definition
    });
  };

  var _proto = ServiceForm.prototype;

  _proto.render = function render() {
    var definition = this.state.definition;
    return h("div", {
      className: themeUtil(styles$h, 'service-form')
    }, h(ReactFromJSONSchema, {
      definition: definition,
      onChange: this._handleOnChange,
      mapping: {
        "default": function _default(_ref) {
          var _type = _ref._type;
          return h("div", {
            style: {
              whiteSpace: 'nowrap'
            }
          }, "Missing input for ", _type);
        },
        entry: ServiceEntry,
        array: ServiceInputMultiSelect,
        "boolean": ServiceInputCheckbox,
        "enum": ServiceInputSelect,
        number: ServiceInputNumber,
        object: ServiceInputJSON,
        string: ServiceInput
      }
    }));
  };

  return ServiceForm;
}(Component);

ServiceForm.propTypes = {
  onChange: PropTypes.func,
  restrictToFirstExample: PropTypes.bool,
  service: PropTypes.object
};
var sdk = new SaasifySDK();

var requestService = function requestService(_ref) {
  var auth = _ref.auth,
      service = _ref.service,
      data = _ref.data;

  try {
    var _auth$consumer;

    sdk.token = (_auth$consumer = auth.consumer) === null || _auth$consumer === void 0 ? void 0 : _auth$consumer.token;
    return Promise.resolve(_catch(function () {
      return Promise.resolve(sdk.call(service.url, {
        method: service.httpMethod.toUpperCase(),
        data: data
      })).then(function (result) {
        if (result.body && result.contentType) {
          if (result.contentType.startsWith('image/')) {
            result.body = result.body.toString('base64');
          }
        }

        return {
          output: result.body,
          outputContentType: result.contentType,
          outputContentTypeParsed: result.contentTypeParsed,
          hitRateLimit: result.hitRateLimit
        };
      });
    }, function (e) {
      return {
        outputError: e.message
      };
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

function getUpgradeLink(_ref) {
  var auth = _ref.auth,
      deployment = _ref.deployment;
  var pricingPlans = deployment.pricingPlans;

  if (auth.isAuthenticated) {
    if (pricingPlans.length === 2) {
      return "/checkout?plan=" + pricingPlans[1].slug;
    }
  }

  return '/pricing';
}

var styles$i = {
  "live-service-demo": "styles-module_live-service-demo__DoPMu",
  "tabs": "styles-module_tabs__2CyNw",
  "tab": "styles-module_tab__aSrTy",
  "selected-tab": "styles-module_selected-tab__3dI5_",
  "tab-content": "styles-module_tab-content__2_tVx",
  "tab-pane": "styles-module_tab-pane__OW_D4",
  "selected-tab-pane": "styles-module_selected-tab-pane__3GYJM",
  "code": "styles-module_code__2Trt9",
  "icons": "styles-module_icons__3p-_D",
  "run": "styles-module_run__MILHS",
  "info": "styles-module_info__k8XYO",
  "copy": "styles-module_copy__4IJF5",
  "output": "styles-module_output__4AYR9",
  "output__cta": "styles-module_output__cta__2zmPG",
  "output__cta__message": "styles-module_output__cta__message__16646",
  "error": "styles-module_error__1yieO",
  "message": "styles-module_message__3fUMb",
  "img-wrapper": "styles-module_img-wrapper__3gJdm",
  "output--flush": "styles-module_output--flush__2vriC",
  "api-playground": "styles-module_api-playground__1o3wS",
  "footer": "styles-module_footer__hCZ3g",
  "footer__service": "styles-module_footer__service__2xVeq",
  "footer__service__path": "styles-module_footer__service__path__3HmlT",
  "footer__service__name": "styles-module_footer__service__name__QJVro",
  "footer__actions": "styles-module_footer__actions__MNTMF",
  "footer__action": "styles-module_footer__action__1q_lb",
  "footer__service__badge": "styles-module_footer__service__badge__3IGwq",
  "footer__service__badge--GET": "styles-module_footer__service__badge--GET__wUZjc",
  "footer__service__badge--POST": "styles-module_footer__service__badge--POST__1PNX7",
  "footer__service__example-description": "styles-module_footer__service__example-description__4uyhU"
};

var _dec$c, _class$f, _class2$c, _temp$d;

var getContentTypeForBuffer = function getContentTypeForBuffer(buffer) {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(fileType.fromBuffer(buffer)).then(function (ft) {
        if (ft) {
          return {
            outputContentType: ft.mime
          };
        }

        var str = buffer.toString('utf8');

        if (isHtml(str)) {
          return {
            outputContentType: 'text/html',
            output: str
          };
        }

        try {
          var json = JSON.parse(str);
          return {
            outputContentType: 'application/json',
            output: json
          };
        } catch (err) {}

        var csv = detectCsv(str);

        if (csv) {
          return {
            outputContentType: 'text/csv',
            output: str
          };
        }
      });
    }, function (err) {
      console.warn('getContentTypeForBuffer error', err);
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var LiveServiceDemo = (_dec$c = inject('auth'), _dec$c(_class$f = observer(_class$f = (_temp$d = _class2$c = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LiveServiceDemo, _Component);

  function LiveServiceDemo() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      selected: 'Playground',
      copiedTextToClipboard: false,
      running: null,
      values: {}
    };
    _this._zoom = mediumZoom({
      background: '#fff',
      margin: 48
    });
    _this._onClickPlaygroundTabMem = mem(function () {
      return function () {
        return _this._onClickTab({
          label: 'Playground'
        });
      };
    });
    _this._onClickTabMem = mem(function (i) {
      return function () {
        return _this._onClickTab(_this._example.snippets[i]);
      };
    });

    _this._onClickTab = function (language) {
      _this.setState({
        selected: language.label
      });
    };

    _this._onClickCopy = function () {
      var selected = _this.state.selected;

      var snippet = _this._example.snippets.find(function (l) {
        return l.label === selected;
      });

      copyTextToClipboard(snippet.code);

      _this.setState({
        copiedTextToClipboard: true
      });

      _this._clearCopyTimeout();

      _this._copyTimeout = setTimeout(_this._onCopyTimeout, 3000);
    };

    _this._onCopyTimeout = function () {
      _this._clearCopyTimeout();

      _this.setState({
        copiedTextToClipboard: false
      });
    };

    _this._clearCopyTimeout = function () {
      if (_this._copyTimeout) {
        clearTimeout(_this._copyTimeout);
        _this._copyTimeout = null;
      }
    };

    _this._onClickRun = function () {
      try {
        var _temp4 = function _temp4() {
          _this.setState(_extends({}, result, {
            running: false
          }));
        };

        var handleResult = function handleResult() {
          try {
            var _temp10 = function () {
              if (!result.hitRateLimit && result.outputContentType) {
                var _temp11 = function () {
                  if (result.outputUrl) {
                    if (result.outputContentType.startsWith('image/')) {} else {
                      window.open(result.outputUrl);
                    }
                  } else {
                    var _temp12 = function _temp12() {
                      if (result.outputContentType.startsWith('text/') && !result.outputContentType.startsWith('text/html') && !result.outputContentType.startsWith('text/csv')) {} else if (result.outputContentType.startsWith('application/json')) {} else if (result.outputContentType.startsWith('image/')) {} else {
                        var blob = new window.Blob([result.origOutput || result.output], {
                          type: result.outputContentType
                        });
                        var ext = mime.extension(result.outputContentType);
                        var filename = ext ? "example." + ext : "example";
                        result.downloaded = true;
                        download(blob, filename, result.outputContentType);
                      }
                    };

                    var _temp13 = function () {
                      if (result.outputContentType.startsWith('application/octet-stream')) {
                        return Promise.resolve(getContentTypeForBuffer(result.output)).then(function (overrides) {
                          if (overrides) {
                            result.origOutput = result.output;
                            result = _extends({}, result, {}, overrides);
                          }
                        });
                      }
                    }();

                    return _temp13 && _temp13.then ? _temp13.then(_temp12) : _temp12(_temp13);
                  }
                }();

                if (_temp11 && _temp11.then) return _temp11.then(function () {});
              }
            }();

            return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(function () {}) : void 0);
          } catch (e) {
            return Promise.reject(e);
          }
        };

        var _this$props = _this.props,
            auth = _this$props.auth,
            service = _this$props.service;

        _this.setState({
          running: true,
          output: null,
          outputUrl: null,
          outputContentType: null,
          outputError: null,
          downloaded: false,
          hitRateLimit: null
        });

        var data = _extends({}, _this._example.input, {}, _this.state.values);

        var builtInExample = service.examples.find(function (e) {
          return isDeepEqual(e.input, data) && e.outputContentType && (e.outputUrl || e.output);
        });
        var result;
        console.log({
          data: data,
          builtInExample: builtInExample
        });

        var _temp5 = function () {
          if (builtInExample) {
            result = {
              output: builtInExample.output,
              outputUrl: builtInExample.outputUrl,
              outputContentType: builtInExample.outputContentType
            };
            return Promise.resolve(new Promise(function (resolve) {
              setTimeout(resolve, 750);
            })).then(function () {
              return Promise.resolve(handleResult()).then(function () {});
            });
          } else {
            return Promise.resolve(requestService({
              auth: auth,
              service: service,
              data: data
            })).then(function (_requestService) {
              result = _requestService;
              return Promise.resolve(handleResult()).then(function () {});
            });
          }
        }();

        return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(_temp4) : _temp4(_temp5));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this._handlePlaygroundChange = function (values) {
      _this.setState({
        values: values
      });
    };

    return _this;
  }

  var _proto = LiveServiceDemo.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._copyTimeout) {
      clearTimeout(this._copyTimeout);
      this._copyTimeout = null;
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        service = _this$props2.service,
        auth = _this$props2.auth,
        deployment = _this$props2.deployment;
    var codeBlockOutputFlush = deployment.saas.theme.codeBlockOutputFlush;
    var _this$state = this.state,
        selected = _this$state.selected,
        copiedTextToClipboard = _this$state.copiedTextToClipboard,
        running = _this$state.running,
        output = _this$state.output,
        outputUrl = _this$state.outputUrl,
        outputContentType = _this$state.outputContentType,
        outputError = _this$state.outputError,
        downloaded = _this$state.downloaded,
        hitRateLimit = _this$state.hitRateLimit;

    try {
      this._example = getServiceExamples(service, auth.consumer && auth.consumer.token, {
        method: service.httpMethod.toUpperCase()
      });
    } catch (err) {
      console.warn('error generating service examples', service, err);
      return null;
    }

    if (!this._example) {
      return null;
    }

    var renderedOutput = null;

    if (outputError) {
      renderedOutput = h("div", {
        className: themeUtil(styles$i, 'error')
      }, outputError);
    } else if (hitRateLimit) {
      renderedOutput = h("div", {
        className: themeUtil(styles$i, 'output__cta')
      }, h("div", {
        className: themeUtil(styles$i, 'output__cta__message')
      }, "You've hit our public rate limit. To keep using the API, please upgrade or try again later."), h("div", {
        className: themeUtil(styles$i, 'output__cta__button')
      }, h(Link$2, {
        to: getUpgradeLink({
          auth: auth,
          deployment: deployment
        })
      }, h(Button, {
        type: "primary"
      }, "Upgrade"))));
    } else if (outputContentType) {
      if (downloaded) {
        renderedOutput = h("div", {
          className: themeUtil(styles$i, 'message')
        }, "The resulting \"", outputContentType, "\" file was downloaded.");
      } else if (outputUrl) {
        if (outputContentType.startsWith('image/')) {
          renderedOutput = h("div", {
            className: themeUtil(styles$i, 'img-wrapper')
          }, h(ImageZoom, {
            src: outputUrl,
            alt: this._example.name || 'Example output',
            zoom: this._zoom
          }));
        }
      } else if (output) {
        if (outputContentType.startsWith('text/')) {
          renderedOutput = h(CodeBlock, {
            className: themeUtil(styles$i, 'code'),
            language: outputContentType.slice('text/'.length),
            value: output
          });
        } else if (outputContentType.startsWith('application/json')) {
          var language;
          var value;

          if (typeof output === 'string') {
            language = 'text';
            value = output;
          } else {
            language = 'json';
            value = JSON.stringify(output, null, 2);
          }

          renderedOutput = h(CodeBlock, {
            className: themeUtil(styles$i, 'code'),
            language: language,
            value: value
          });
        } else if (outputContentType.startsWith('image/')) {
          var dataUrl = 'data:' + outputContentType + ';base64,' + output;
          renderedOutput = h("div", {
            className: themeUtil(styles$i, 'img-wrapper')
          }, h(ImageZoom, {
            src: dataUrl,
            alt: this._example.name || 'Example output',
            zoom: this._zoom
          }));
        } else {
          renderedOutput = h("div", {
            className: themeUtil(styles$i, 'message')
          }, "The resulting \"", outputContentType, "\" file preview is not supported.");
        }
      }
    }

    return h("div", {
      className: themeUtil(styles$i, 'live-service-demo')
    }, h("div", {
      className: themeUtil(styles$i, 'tabs')
    }, h("div", {
      className: themeUtil(styles$i, 'tab', selected === 'Playground' && themeUtil(styles$i, 'selected-tab')),
      onClick: this._onClickPlaygroundTabMem()
    }, "Playground"), this._example.snippets.map(function (l, i) {
      return h("div", {
        className: themeUtil(styles$i, 'tab', selected === l.label && themeUtil(styles$i, 'selected-tab')),
        key: i,
        onClick: _this2._onClickTabMem(i)
      }, l.label);
    })), h("div", {
      className: themeUtil(styles$i, 'tab-content')
    }, h("div", {
      className: themeUtil(styles$i, 'tab-pane', selected === 'Playground' && themeUtil(styles$i, 'selected-tab-pane'))
    }, h("div", {
      className: themeUtil(styles$i, 'api-playground')
    }, h(ServiceForm, {
      onChange: this._handlePlaygroundChange,
      restrictToFirstExample: true,
      service: service
    }))), this._example.snippets.map(function (l, i) {
      return h("div", {
        className: themeUtil(styles$i, 'tab-pane', selected === l.label && themeUtil(styles$i, 'selected-tab-pane')),
        key: i
      }, h(CodeBlock, {
        className: themeUtil(styles$i, 'code'),
        language: l.language,
        value: l.code
      }));
    })), h("div", {
      className: themeUtil(styles$i, 'footer')
    }, h("div", {
      className: themeUtil(styles$i, 'footer__service')
    }, this._example.description && h("div", {
      className: themeUtil(styles$i, 'footer__service__example-description')
    }, "Example - ", this._example.description), h("div", {
      className: themeUtil(styles$i, 'footer__service__path')
    }, h("div", {
      className: themeUtil(styles$i, 'footer__service__badge', themeUtil(styles$i, "footer__service__badge--" + service.httpMethod.toUpperCase()))
    }, service.httpMethod.toUpperCase()), "/", h("div", {
      className: themeUtil(styles$i, 'footer__service__name')
    }, service.path.slice(1)))), h("div", {
      className: themeUtil(styles$i, 'footer__actions')
    }, selected !== 'Playground' && h("div", {
      className: themeUtil(styles$i, 'footer__action')
    }, h(Tooltip, {
      placement: "top",
      title: copiedTextToClipboard ? 'Copied!' : 'Copy to clipboard'
    }, h(Button, {
      icon: "copy",
      type: "primary",
      className: themeUtil(styles$i, 'copy'),
      onClick: this._onClickCopy
    }))), h("div", {
      className: themeUtil(styles$i, 'footer__action')
    }, h(Button, {
      onClick: this._onClickRun,
      type: "secondary",
      loading: running
    }, "Run example")))), renderedOutput && h("div", {
      className: themeUtil(styles$i, 'output', hitRateLimit && themeUtil(styles$i, 'output--hit-rate-limit'), codeBlockOutputFlush && themeUtil(styles$i, 'output--flush'))
    }, renderedOutput));
  };

  return LiveServiceDemo;
}(Component), _class2$c.propTypes = {
  deployment: PropTypes.object.isRequired,
  service: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
}, _temp$d)) || _class$f) || _class$f);
var styles$j = {
  "paper": "styles-module_paper__XLfZX"
};

var Paper = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Paper, _Component);

  function Paper() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Paper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        rest = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    return h("div", _extends({
      className: themeUtil(styles$j, 'paper', className)
    }, rest));
  };

  return Paper;
}(Component);

var infinity = require("./infinity~32a569ce3c4623f336c656e2f1c9c7b00f775c41.svg");

var styles$k = {
  "plan": "styles-module_plan__1ERxa",
  "name": "styles-module_name__UBB4r",
  "infinity": "styles-module_infinity__ut16b",
  "price": "styles-module_price__29T1Z",
  "dollas": "styles-module_dollas__jyUex",
  "pricing": "styles-module_pricing__2PC7R",
  "emphasis": "styles-module_emphasis__NuYIW",
  "features": "styles-module_features__1mVh2",
  "feature": "styles-module_feature__3XnB-",
  "-webkit-box-flex": "styles-module_flex__1aELq",
  "flex": "styles-module_flex__1aELq"
};

var _dec$d, _class$g, _class2$d, _temp$e;

var allowedTypes$1 = ['strong', 'text', 'emphasis', 'link', 'linkReference', 'delete', 'inlineCode'];

var CustomLink = function CustomLink(_ref) {
  var to = _ref.to,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["to", "children"]);

  return to && to.indexOf(':') >= 0 ? h("a", _extends({
    href: to
  }, rest), children) : h(Link$2, _extends({
    to: to
  }, rest), children);
};

var PricingPlan = (_dec$d = inject('auth'), _dec$d(_class$g = observer(_class$g = (_temp$e = _class2$d = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PricingPlan, _Component);

  function PricingPlan() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PricingPlan.prototype;

  _proto.render = function render() {
    var _plan$context, _plan$context2, _auth$consumer, _auth$consumer2;

    var _this$props = this.props,
        auth = _this$props.auth,
        plan = _this$props.plan,
        inline = _this$props.inline,
        className = _this$props.className,
        rest = _objectWithoutPropertiesLoose(_this$props, ["auth", "plan", "inline", "className"]);

    var isCurrentPlan = auth.consumer ? auth.consumer.plan === plan.slug : auth.isAuthenticated && plan.isFree;
    var isDowngrade = !isCurrentPlan && auth.consumer && auth.consumer.plan && auth.consumer.plan !== 'free' && auth.consumer.plan !== plan.slug && plan.isFree;
    var actionLink = plan.ctaLink || (plan.onClickCTA ? '' : isDowngrade ? '/dashboard' : "/signup?plan=" + plan.slug);
    return h(Paper, _extends({
      className: themeUtil(styles$k, 'plan', className)
    }, rest), h("h3", {
      className: themeUtil(styles$k, 'name')
    }, plan.name, " ", inline ? 'Plan' : ''), h(Divider, null), (((_plan$context = plan.context) === null || _plan$context === void 0 ? void 0 : _plan$context.hasMeteredBilling) || ((_plan$context2 = plan.context) === null || _plan$context2 === void 0 ? void 0 : _plan$context2.hasRateLimits)) && plan.context.showMeteredBilling && h(Fragment, null, h("div", {
      className: themeUtil(styles$k, 'pricing')
    }, h("div", null), h("div", {
      className: themeUtil(styles$k, 'column')
    }, "Price"), h("div", {
      className: themeUtil(styles$k, 'column')
    }, "Rate Limit"), plan.requests && h(Fragment, null, h("div", {
      className: themeUtil(styles$k, 'emphasis')
    }, "API Calls"), h("div", null, plan.requests.price), plan.requests.rateLimit || h("img", {
      alt: "unlimited",
      src: infinity,
      className: themeUtil(styles$k, 'infinity')
    })), plan.metrics && plan.metrics.map(function (metric) {
      return h(Fragment, {
        key: metric.slug
      }, h("div", {
        className: themeUtil(styles$k, 'emphasis')
      }, metric.label), h("div", null, metric.price), metric.rateLimit || h("img", {
        alt: "unlimited",
        src: infinity,
        className: themeUtil(styles$k, 'infinity')
      }));
    })), (!plan.features || !plan.features.length) && h("div", {
      className: themeUtil(styles$k, 'flex')
    }), h(Divider, null)), plan.features && plan.features.length > 0 && h(Fragment, null, h("div", {
      className: themeUtil(styles$k, 'features')
    }, plan.features.map(function (feature, index) {
      return h("div", {
        className: themeUtil(styles$k, 'feature'),
        key: index
      }, typeof feature === 'string' ? h(ReactMarkdown, {
        source: feature,
        allowedTypes: allowedTypes$1,
        unwrapDisallowed: true
      }) : feature);
    })), h("div", {
      className: themeUtil(styles$k, 'flex')
    }), h(Divider, null)), plan.desc && h("div", {
      className: themeUtil(styles$k, 'desc'),
      style: {
        color: themeUtil['@primary-color']
      }
    }, plan.desc), plan.price && h("div", {
      className: themeUtil(styles$k, 'price')
    }, h("span", {
      className: themeUtil(styles$k, 'dollas')
    }, plan.price), plan.interval && h("span", null, " / ", plan.interval)), !inline && (isCurrentPlan ? h(CTAButton, {
      disabled: true,
      type: plan.type
    }, "Current plan") : h(CustomLink, {
      to: actionLink,
      onClick: plan.onClickCTA
    }, h(CTAButton, {
      type: plan.type,
      className: cs(plan.type === 'secondary' && themeUtil(styles$k, 'secondaryCTAButton'))
    }, plan.cta || (isDowngrade ? 'Downgrade' : ((_auth$consumer = auth.consumer) === null || _auth$consumer === void 0 ? void 0 : _auth$consumer.enabled) ? ((_auth$consumer2 = auth.consumer) === null || _auth$consumer2 === void 0 ? void 0 : _auth$consumer2.plan) === 'free' ? 'Upgrade' : 'Switch plans' : 'Get started')))));
  };

  return PricingPlan;
}(Component), _class2$d.propTypes = {
  auth: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  inline: PropTypes.bool,
  className: PropTypes.string
}, _class2$d.defaultProps = {
  inline: false
}, _temp$e)) || _class$g) || _class$g);
var styles$l = {
  "markdown": "styles-module_markdown__1koJC",
  "highlight": "styles-module_highlight__1G8rA",
  "subtitle": "styles-module_subtitle__1b5D3",
  "anchor": "styles-module_anchor__oolNz",
  "waiting": "styles-module_waiting__2dKV3",
  "edit-button": "styles-module_edit-button__3H0Xr",
  "anticon": "styles-module_anticon__crNX1"
};

var Markdown = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Markdown, _Component);

  function Markdown() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Markdown.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        source = _this$props.source,
        renderers = _this$props.renderers,
        rest = _objectWithoutPropertiesLoose(_this$props, ["source", "renderers"]);

    return h(ReactMarkdown, _extends({
      className: themeUtil(styles$l, 'markdown'),
      source: source,
      escapeHtml: false,
      linkTarget: "_blank",
      renderers: _extends({
        code: CodeBlock
      }, renderers)
    }, rest));
  };

  return Markdown;
}(Component);

Markdown.propTypes = {
  source: PropTypes.string.isRequired,
  renderers: PropTypes.object
};
Markdown.defaultProps = {
  renderers: {}
};

var ScrollToTopOnMount = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ScrollToTopOnMount, _Component);

  function ScrollToTopOnMount() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ScrollToTopOnMount.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.scrollTo(0, 0);
  };

  _proto.render = function render() {
    return null;
  };

  return ScrollToTopOnMount;
}(Component);

var EventEmitter = new EventEmitter3();
var styles$m = {
  "layoutCentered": "styles-module_layoutCentered__3oVm0"
};

var LayoutCentered = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LayoutCentered, _Component);

  function LayoutCentered() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = LayoutCentered.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        style = _this$props.style;
    return h("div", {
      className: styles$m.layoutCentered + " " + (className || ''),
      style: style
    }, children);
  };

  return LayoutCentered;
}(Component);

LayoutCentered.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.any
};
var styles$n = {
  "loadingIndicator": "styles-module_loadingIndicator__3MPEY"
};
var darkStyle = {
  background: 'rgba(0, 0, 0, 0.6)'
};
var lightStyle = {
  background: 'transparent'
};

var LoadingIndicator = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(LoadingIndicator, _PureComponent);

  function LoadingIndicator() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = LoadingIndicator.prototype;

  _proto.render = function render() {
    var dark = this.props.dark;
    return h(LayoutCentered, {
      className: styles$n.loadingIndicator,
      style: dark ? darkStyle : lightStyle
    }, "Loading...");
  };

  return LoadingIndicator;
}(PureComponent);

LoadingIndicator.propTypes = {
  dark: PropTypes.bool
};
LoadingIndicator.defaultProps = {
  dark: true
};
var styles$o = {
  "infiniteList": "styles-module_infiniteList__2uHBW",
  "scrollNode": "styles-module_scrollNode__3aXpV",
  "loadingSection": "styles-module_loadingSection__wqZ6j",
  "refresh": "styles-module_refresh__3RRak"
};

var _class$h, _class2$e, _temp$f;

var InfiniteList = observer(_class$h = (_temp$f = _class2$e = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InfiniteList, _Component);

  function InfiniteList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      windowHeight: window.innerHeight
    };

    _this.onComponentResize = function () {
      if (window.innerHeight !== _this.state.windowHeight) {
        _this.setState({
          windowHeight: window.innerHeight
        });
      }
    };

    _this._onScroll = function (event) {
      var _this$props = _this.props,
          query = _this$props.query,
          pagingThresholdPercentage = _this$props.pagingThresholdPercentage;

      if (query.isLoading || query.status === 'complete') {
        return;
      }

      var node = event.target;

      var scrollNode = _this._getNode();

      if (node !== scrollNode) {
        return;
      }

      if (node.scrollTop + node.clientHeight >= node.scrollHeight - node.clientHeight * pagingThresholdPercentage) {
        _this._loadMore();
      }
    };

    _this._refresh = function () {
      _this.props.query.refresh();
    };

    return _this;
  }

  var _proto = InfiniteList.prototype;

  _proto.componentDidMount = function componentDidMount() {
    EventEmitter.on('refresh', this._refresh);
    window.addEventListener('resize', this.onComponentResize);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    EventEmitter.removeListener('refresh', this._refresh);

    if (this._disablePointerEventsHandle) {
      clearTimeout(this._disablePointerEventsHandle);
    }

    if (this._loadMoreHandle) {
      raf.cancel(this._loadMoreHandle);
    }

    window.removeEventListener('resize', this.onComponentResize);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        query = _this$props2.query,
        footer = _this$props2.footer,
        renderContent = _this$props2.renderContent,
        className = _this$props2.className,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["query", "footer", "renderContent", "pagingThresholdPercentage", "className", "style"]);

    if (query.status === 'error') {
      return h(LayoutCentered, rest, "Error loading results. Please refresh the page or contact support.");
    }

    if (query.isLoadingInitialResults) {
      return h(LoadingIndicator, _extends({
        dark: false
      }, rest));
    } else {
      return h("div", _extends({
        className: cs(styles$o.infiniteList, className)
      }, rest), h("div", {
        ref: "scrollNode",
        className: styles$o.scrollNode,
        onScroll: this._onScroll
      }, renderContent(query.results)), footer, h("div", {
        className: styles$o.loadingSection
      }, query.isLoading && h("div", {
        className: styles$o.refresh
      }, "Loading...")));
    }
  };

  _proto._getNode = function _getNode() {
    return this.refs.scrollNode && ReactDOM.findDOMNode(this.refs.scrollNode);
  };

  _proto._loadMore = function _loadMore() {
    var _this2 = this;

    if (this._loadMoreHandle) {
      return;
    }

    this._loadMoreHandle = raf(function () {
      _this2._loadMoreHandle = null;

      _this2.props.query.load();
    });
  };

  return InfiniteList;
}(Component), _class2$e.propTypes = {
  query: PropTypes.object.isRequired,
  renderContent: PropTypes.func.isRequired,
  pagingThresholdPercentage: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  footer: PropTypes.object
}, _class2$e.defaultProps = {
  pagingThresholdPercentage: 0.01
}, _temp$f)) || _class$h;

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;

var RelativeTimeLabel = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(RelativeTimeLabel, _PureComponent);

  function RelativeTimeLabel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _this._cancel = function () {
      clearTimeout(_this._refreshTimeout);
      _this._refreshTimeout = null;
    };

    _this._refresh = function () {
      _this._cancel();

      var random = Math.random();
      var delta = Math.abs(new Date() - _this.props.time);
      var timeout;

      if (delta < ONE_MINUTE) {
        timeout = 10 * ONE_SECOND;
      } else if (delta < 10 * ONE_MINUTE) {
        timeout = ONE_MINUTE;
      } else if (delta < ONE_HOUR) {
        timeout = ONE_MINUTE + random * 5 * ONE_SECOND;
      } else if (delta < ONE_DAY) {
        timeout = ONE_HOUR + random * 5 * ONE_MINUTE;
      } else {
        timeout = ONE_DAY + random * 10 * ONE_MINUTE;
      }

      _this._refreshTimeout = setTimeout(_this._refresh, timeout);
    };

    return _this;
  }

  var _proto = RelativeTimeLabel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._refresh();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._cancel();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        time = _this$props.time,
        rest = _objectWithoutPropertiesLoose(_this$props, ["time"]);

    var delta = new Date() - new Date(time);
    var timestamp;

    if (delta <= 2000 && delta >= -20000) {
      timestamp = 'just now';
    } else {
      timestamp = ms(delta, {
        "long": true
      }) + " ago";
    }

    return h("span", rest, timestamp);
  };

  return RelativeTimeLabel;
}(PureComponent);

RelativeTimeLabel.propTypes = {
  time: PropTypes.string.isRequired
};

var stripeIcon = require("./stripe~e7bf7d8afb1b37b6ff9601affd9504a6d6592e36.svg");

var spotifyIcon = require("./spotify~9fcde0824cd6ad815791a779010daa81ceaed303.svg");

var styles$p = {
  "authProviders": "styles-module_authProviders__21Ryr",
  "authProvider": "styles-module_authProvider__1SgbT",
  "icon": "styles-module_icon__3Iu1c"
};

var _dec$e, _class$i, _class2$f, _temp$g;

var AuthProviders = (_dec$e = inject('auth'), _dec$e(_class$i = withRouter(_class$i = observer(_class$i = (_temp$g = _class2$f = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthProviders, _Component);

  function AuthProviders() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this._onClickGitHub = function (e) {
      e.preventDefault();
      authGitHub();
    };

    _this._onClickGoogle = function (e) {
      e.preventDefault();
      authGoogle({
        location: _this.props.location
      }, _this.props.authParams);
    };

    _this._onClickSpotify = function (e) {
      e.preventDefault();
      authSpotify({
        location: _this.props.location
      });
    };

    _this._onClickTwitter = function (e) {
      e.preventDefault();
      authTwitter({
        location: _this.props.location
      });
    };

    _this._onClickLinkedIn = function (e) {
      e.preventDefault();
      authLinkedIn({
        location: _this.props.location
      });
    };

    _this._onClickStripe = function (e) {
      e.preventDefault();
      authStripe({
        location: _this.props.location,
        auth: _this.props.auth
      });
    };

    return _this;
  }

  var _proto = AuthProviders.prototype;

  _proto.render = function render() {
    var _authConfig$github, _authConfig$google, _authConfig$spotify, _authConfig$twitter, _authConfig$linkedin, _authConfig$stripe, _auth$user$providers$, _auth$user$providers$2, _auth$user$providers$3, _auth$user$providers$4, _auth$user$providers$5, _auth$user$providers$6, _authConfig$github2, _authConfig$github3, _authConfig$google2, _authConfig$google3, _authConfig$spotify2, _authConfig$spotify3, _authConfig$linkedin2, _authConfig$linkedin3, _authConfig$twitter2, _authConfig$twitter3, _authConfig$stripe2, _authConfig$stripe3;

    var _this$props = this.props,
        className = _this$props.className,
        authConfig = _this$props.authConfig,
        auth = _this$props.auth,
        rest = _objectWithoutPropertiesLoose(_this$props, ["className", "authConfig", "authParams", "auth", "location", "staticContext"]);

    var hasGitHubAuth = ((_authConfig$github = authConfig.github) === null || _authConfig$github === void 0 ? void 0 : _authConfig$github.enabled) !== false;
    var hasGoogleAuth = ((_authConfig$google = authConfig.google) === null || _authConfig$google === void 0 ? void 0 : _authConfig$google.enabled) !== false;
    var hasSpotifyAuth = ((_authConfig$spotify = authConfig.spotify) === null || _authConfig$spotify === void 0 ? void 0 : _authConfig$spotify.enabled) !== false;
    var hasTwitterAuth = ((_authConfig$twitter = authConfig.twitter) === null || _authConfig$twitter === void 0 ? void 0 : _authConfig$twitter.enabled) !== false;
    var hasLinkedInAuth = ((_authConfig$linkedin = authConfig.linkedin) === null || _authConfig$linkedin === void 0 ? void 0 : _authConfig$linkedin.enabled) !== false;
    var hasStripeAuth = ((_authConfig$stripe = authConfig.stripe) === null || _authConfig$stripe === void 0 ? void 0 : _authConfig$stripe.enabled) !== false;
    var isGitHubLinked = (_auth$user$providers$ = auth.user.providers.github) === null || _auth$user$providers$ === void 0 ? void 0 : _auth$user$providers$.id;
    var isGoogleLinked = (_auth$user$providers$2 = auth.user.providers.google) === null || _auth$user$providers$2 === void 0 ? void 0 : _auth$user$providers$2.id;
    var isSpotifyLinked = (_auth$user$providers$3 = auth.user.providers.spotify) === null || _auth$user$providers$3 === void 0 ? void 0 : _auth$user$providers$3.id;
    var isTwitterLinked = (_auth$user$providers$4 = auth.user.providers.twitter) === null || _auth$user$providers$4 === void 0 ? void 0 : _auth$user$providers$4.id;
    var isLinkedInLinked = (_auth$user$providers$5 = auth.user.providers.linkedin) === null || _auth$user$providers$5 === void 0 ? void 0 : _auth$user$providers$5.id;
    var isStripeLinked = (_auth$user$providers$6 = auth.user.providers.stripe) === null || _auth$user$providers$6 === void 0 ? void 0 : _auth$user$providers$6.id;
    console.log('user', toJS(auth.user));
    return h("div", _extends({
      className: cs(styles$p.authProviders, className)
    }, rest), hasGitHubAuth && h("div", {
      className: styles$p.authProvider
    }, h(Button, {
      className: styles$p.authButton,
      icon: "github",
      type: ((_authConfig$github2 = authConfig.github) === null || _authConfig$github2 === void 0 ? void 0 : _authConfig$github2.type) || 'secondary',
      onClick: this._onClickGitHub
    }, isGitHubLinked ? 'Re-link GitHub' : 'Link GitHub'), (_authConfig$github3 = authConfig.github) === null || _authConfig$github3 === void 0 ? void 0 : _authConfig$github3.detail), hasGoogleAuth && h("div", {
      className: styles$p.authProvider
    }, h(Button, {
      className: styles$p.authButton,
      icon: "google",
      type: ((_authConfig$google2 = authConfig.google) === null || _authConfig$google2 === void 0 ? void 0 : _authConfig$google2.type) || 'secondary',
      onClick: this._onClickGoogle
    }, isGoogleLinked ? 'Re-link Google' : 'Link Google'), (_authConfig$google3 = authConfig.google) === null || _authConfig$google3 === void 0 ? void 0 : _authConfig$google3.detail), hasSpotifyAuth && h("div", {
      className: styles$p.authProvider
    }, h(Button, {
      className: styles$p.authButton,
      type: ((_authConfig$spotify2 = authConfig.spotify) === null || _authConfig$spotify2 === void 0 ? void 0 : _authConfig$spotify2.type) || 'secondary',
      onClick: this._onClickSpotify
    }, h("img", {
      className: styles$p.icon,
      src: spotifyIcon,
      alt: "Spotify logo"
    }), isSpotifyLinked ? 'Re-link Spotify' : 'Link Spotify'), (_authConfig$spotify3 = authConfig.spotify) === null || _authConfig$spotify3 === void 0 ? void 0 : _authConfig$spotify3.detail), hasLinkedInAuth && h("div", {
      className: styles$p.authProvider
    }, h(Button, {
      className: styles$p.authButton,
      icon: "linkedin",
      type: ((_authConfig$linkedin2 = authConfig.linkedin) === null || _authConfig$linkedin2 === void 0 ? void 0 : _authConfig$linkedin2.type) || 'secondary',
      onClick: this._onClickLinkedIn
    }, isLinkedInLinked ? 'Re-link LinkedIn' : 'Link LinkedIn'), (_authConfig$linkedin3 = authConfig.linkedin) === null || _authConfig$linkedin3 === void 0 ? void 0 : _authConfig$linkedin3.detail), hasTwitterAuth && h("div", {
      className: styles$p.authProvider
    }, h(Button, {
      className: styles$p.authButton,
      icon: "twitter",
      type: ((_authConfig$twitter2 = authConfig.twitter) === null || _authConfig$twitter2 === void 0 ? void 0 : _authConfig$twitter2.type) || 'secondary',
      onClick: this._onClickTwitter
    }, isTwitterLinked ? 'Re-link Twitter' : 'Link Twitter'), (_authConfig$twitter3 = authConfig.twitter) === null || _authConfig$twitter3 === void 0 ? void 0 : _authConfig$twitter3.detail), hasStripeAuth && h("div", {
      className: styles$p.authProvider
    }, h(Button, {
      className: styles$p.authButton,
      type: ((_authConfig$stripe2 = authConfig.stripe) === null || _authConfig$stripe2 === void 0 ? void 0 : _authConfig$stripe2.type) || 'secondary',
      onClick: this._onClickStripe
    }, h("img", {
      className: styles$p.icon,
      src: stripeIcon,
      alt: "Stripe logo"
    }), isStripeLinked ? 'Re-link Stripe Account' : 'Link Stripe Account'), (_authConfig$stripe3 = authConfig.stripe) === null || _authConfig$stripe3 === void 0 ? void 0 : _authConfig$stripe3.detail));
  };

  return AuthProviders;
}(Component), _class2$f.propTypes = {
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  authConfig: PropTypes.object,
  authParams: PropTypes.object,
  className: PropTypes.string
}, _class2$f.defaultProps = {
  authConfig: {},
  authParams: {}
}, _temp$g)) || _class$i) || _class$i) || _class$i);

function bootstrap() {
  console.log("\n\nPowered by:\n\n\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2588\u2557  \u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2557   \u2588\u2588\u2557\n\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u255A\u2588\u2588\u2557 \u2588\u2588\u2554\u255D\n\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2557   \u255A\u2588\u2588\u2588\u2588\u2554\u255D\n\u255A\u2550\u2550\u2550\u2550\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2551\u255A\u2550\u2550\u2550\u2550\u2588\u2588\u2551\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u255D    \u255A\u2588\u2588\u2554\u255D\n\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2551  \u2588\u2588\u2551\u2588\u2588\u2551  \u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2551\u2588\u2588\u2551        \u2588\u2588\u2551\n\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D\u255A\u2550\u255D  \u255A\u2550\u255D\u255A\u2550\u255D  \u255A\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D\u255A\u2550\u255D\u255A\u2550\u255D        \u255A\u2550\u255D\n\n   The easiest way to launch your own SaaS!\n            https://saasify.sh\n\n\n");
}

function handleAuth(_ref) {
  var auth = _ref.auth,
      href = _ref.href;
  console.log('handleAuth', auth.isAuthenticated, {
    href: href
  });

  if (auth.isAuthenticated) {
    try {
      var url = new URL(href || window.location.href);
      var plan = url.searchParams.get('plan');

      if (plan) {
        return h(Redirect, {
          to: "/checkout?plan=" + plan
        });
      } else {
        return h(Redirect, {
          to: "/dashboard"
        });
      }
    } catch (err) {
      return h(Redirect, {
        to: "/dashboard"
      });
    }
  } else {
    return h(Redirect, {
      to: "/"
    });
  }
}

var _class$j, _descriptor$1, _descriptor2, _descriptor3, _descriptor4, _temp$h;

var AUTH_STORE_KEY = 'SaasifyAuth';
var AuthManagerClass = (_class$j = (_temp$h = /*#__PURE__*/function () {
  _createClass(AuthManagerClass, [{
    key: "user",
    get: function get() {
      return this.auth && this.auth.user;
    }
  }, {
    key: "isAuthenticated",
    get: function get() {
      return !!this.auth;
    }
  }]);

  function AuthManagerClass() {
    var _this = this;

    _initializerDefineProperty(this, "auth", _descriptor$1, this);

    _initializerDefineProperty(this, "consumer", _descriptor2, this);

    _initializerDefineProperty(this, "context", _descriptor3, this);

    _initializerDefineProperty(this, "isBootstrapping", _descriptor4, this);

    this._bootstrappingP = new Promise(function (resolve) {
      LocalStore.get(AUTH_STORE_KEY).then(function (auth) {
        _this.auth = auth;
        _this.isBootstrapping = false;
        setTimeout(resolve);
      }, function () {
        _this.isBootstrapping = false;
        setTimeout(resolve);
      });
    });
  }

  var _proto = AuthManagerClass.prototype;

  _proto.signin = function signin(opts) {
    try {
      var _this3 = this;

      debug("AuthManager.signin [" + opts.username + "]");
      return Promise.resolve(API.signin(_extends({}, _this3.context, {}, opts))).then(function (auth) {
        function _temp3() {
          _this3.auth = auth;
        }

        var _temp2 = function () {
          if (opts.remember !== false) {
            return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {});
          }
        }();

        return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.signup = function signup(opts) {
    try {
      var _this5 = this;

      debug("AuthManager.signup [" + opts.email + "] [" + opts.username + "]");
      return Promise.resolve(API.signup(_extends({}, _this5.context, {}, opts))).then(function (auth) {
        return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {
          _this5.auth = auth;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.signupForBeta = function signupForBeta(opts) {
    try {
      var _this7 = this;

      debug("AuthManager.signupForBeta [" + opts.email + "] [" + opts.name + "]");
      return Promise.resolve(API.signupForBeta(_extends({}, _this7.context, {}, opts)));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.signout = function signout() {
    try {
      var _this9 = this;

      debug('AuthManager.signout');
      API.signout();
      return Promise.resolve(LocalStore.remove(AUTH_STORE_KEY)).then(function () {
        _this9.auth = null;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.authWithGitHub = function authWithGitHub(opts) {
    try {
      var _this11 = this;

      debug('AuthManager.authWithGitHub');
      return Promise.resolve(_this11._bootstrappingP).then(function () {
        return Promise.resolve(API.authWithGitHub(_extends({}, _this11.context, {}, githubConfig, {}, opts))).then(function (auth) {
          return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {
            _this11.auth = auth;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.authWithGoogle = function authWithGoogle(opts) {
    try {
      var _this13 = this;

      debug('AuthManager.authWithGoogle');
      return Promise.resolve(_this13._bootstrappingP).then(function () {
        return Promise.resolve(API.authWithGoogle(_extends({}, _this13.context, {}, opts))).then(function (auth) {
          return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {
            _this13.auth = auth;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.authWithSpotify = function authWithSpotify(opts) {
    try {
      var _this15 = this;

      debug('AuthManager.authWithSpotify');
      return Promise.resolve(_this15._bootstrappingP).then(function () {
        return Promise.resolve(API.authWithSpotify(_extends({}, _this15.context, {}, opts))).then(function (auth) {
          return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {
            _this15.auth = auth;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.authWithLinkedIn = function authWithLinkedIn(opts) {
    try {
      var _this17 = this;

      debug('AuthManager.authWithLinkedIn');
      return Promise.resolve(_this17._bootstrappingP).then(function () {
        return Promise.resolve(API.authWithLinkedIn(_extends({}, _this17.context, {}, opts))).then(function (auth) {
          return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {
            _this17.auth = auth;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.authWithTwitter = function authWithTwitter(opts) {
    try {
      var _this19 = this;

      debug('AuthManager.authWithTwitter');
      return Promise.resolve(_this19._bootstrappingP).then(function () {
        return Promise.resolve(API.authWithTwitter(_extends({}, _this19.context, {}, opts))).then(function (auth) {
          return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {
            _this19.auth = auth;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.authWithStripe = function authWithStripe(opts) {
    try {
      var _this21 = this;

      debug('AuthManager.authWithStripe');
      return Promise.resolve(_this21._bootstrappingP).then(function () {
        return Promise.resolve(API.authWithStripe(_extends({}, _this21.context, {}, opts))).then(function (auth) {
          return Promise.resolve(LocalStore.set(AUTH_STORE_KEY, auth)).then(function () {
            _this21.auth = auth;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(AuthManagerClass, [{
    key: "bootstrappingP",
    get: function get() {
      return this._bootstrappingP;
    }
  }]);

  return AuthManagerClass;
}(), _temp$h), (_descriptor$1 = _applyDecoratedDescriptor(_class$j.prototype, "auth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class$j.prototype, "consumer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class$j.prototype, "context", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class$j.prototype, "user", [computed], Object.getOwnPropertyDescriptor(_class$j.prototype, "user"), _class$j.prototype), _descriptor4 = _applyDecoratedDescriptor(_class$j.prototype, "isBootstrapping", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class$j.prototype, "isAuthenticated", [computed], Object.getOwnPropertyDescriptor(_class$j.prototype, "isAuthenticated"), _class$j.prototype)), _class$j);
var AuthManager = observable(new AuthManagerClass());
autorun(function () {
  API.user = AuthManager.auth && AuthManager.auth.user;
  API.token = AuthManager.auth && AuthManager.auth.token;
});
window.auth = AuthManager;
var CachePolicy = {
  IgnoreCache: Symbol('IgnoreCache'),
  CacheOnly: Symbol('CacheOnly'),
  NetworkOnly: Symbol('NetworkOnly'),
  CacheElseNetwork: Symbol('CacheElseNetwork'),
  NetworkElseCache: Symbol('NetworkElseCache'),
  CacheThenNetwork: Symbol('CacheThenNetwork')
};
var NetworkUtils = {
  isDebugEnabled: function isDebugEnabled() {
    return window.localStorage && window.localStorage.debugSlowNetwork === 'true';
  },
  addDebugLatency: function addDebugLatency(rpcP) {
    if (NetworkUtils.isDebugEnabled()) {
      var origRpcP = rpcP;
      rpcP = new Promise(function (resolve, reject) {
        setTimeout(function () {
          origRpcP.then(resolve)["catch"](reject);
        }, 10000);
      });
    }

    return rpcP;
  }
};

var _dec$f, _class$k, _descriptor$2, _descriptor2$1, _descriptor3$1, _descriptor4$1, _class2$g, _temp$i;

var ReactLiveQuery = (_dec$f = observable.shallow, (_class$k = (_temp$i = _class2$g = /*#__PURE__*/function () {
  function ReactLiveQuery(opts) {
    var _this = this;

    _initializerDefineProperty(this, "_results", _descriptor$2, this);

    _initializerDefineProperty(this, "isLoadingInitialResults", _descriptor2$1, this);

    _initializerDefineProperty(this, "isLoading", _descriptor3$1, this);

    _initializerDefineProperty(this, "status", _descriptor4$1, this);

    this.notifyUpdates = function (result) {
      if (_this.opts.policy !== CachePolicy.IgnoreCache && _this.opts.policy !== CachePolicy.NetworkOnly) {
        return;
      }

      if (_this.isLoadingInitialResults) {
        return;
      }

      _this.opts.debug('enqueue', _this.opts.model, result);

      if (_this._enqueueHandler) {
        clearTimeout(_this._enqueueHandler);
      }

      if (!_this._enqueued) {
        _this._enqueued = {};
      }

      if (result) {
        if (Array.isArray(result)) {
          result.forEach(function (model) {
            var id = model[_this.opts.key];
            _this._enqueued[id] = true;
          });
        } else {
          var id = result[_this.opts.key];
          _this._enqueued[id] = true;
        }
      }

      _this._enqueueHandler = setTimeout(function () {
        _this._enqueueHandler = null;

        _this._resolveEnqueuedUpdates();
      }, _this._enqueueDebounceTimeout);
    };

    this._resolveEnqueuedUpdates = function () {
      if (_this.status === 'frozen') {
        return;
      }

      var enqueued = _this._enqueued;
      _this._enqueued = {};
      var numEnqueued = Object.keys(enqueued).length;

      _this.opts.debug(_this.opts.model + " processing " + numEnqueued + " enqueued updates", enqueued);

      var limit = Math.max(_this.opts.paged && _this.opts.limit, _this._results.length + numEnqueued);

      _this._loadFromCache({
        offset: 0,
        limit: limit
      }).then(function (results) {
        _this.opts.debug(_this.opts.model + " loaded " + results.length + " from cache after enqueue");

        var numUpdated = 0;
        results = results.map(function (result) {
          var id = result[_this.opts.key];
          var existing = _this._resultsMap[id];

          if (existing) {
            if (enqueued[id]) {
              _this._resultsMap[id] = result;
              numUpdated++;
            } else {
              result = existing;
            }
          } else {
            numUpdated++;
          }

          return result;
        });

        _this._replaceResults(results, numUpdated);
      })["catch"](function (err) {
        _this.opts.debug(_this.opts.model + " error processing enqueued updates", err);
      });
    };

    if (!opts) {
      throw new Error("ReactLiveQuery invalid options " + opts);
    }

    this.opts = _extends({
      network: undefined,
      cache: undefined,
      key: 'id',
      paged: true,
      prepend: false,
      isSingleModel: false,
      limit: 25,
      offset: 0,
      enqueueDebounceTimeout: 150,
      model: undefined,
      policy: CachePolicy.NetworkOnly,
      silent: false,
      transforms: [],
      debug: console.log.bind(console)
    }, opts);
    this._requiresNetwork = false;
    this._requiresCache = false;

    switch (this.opts.policy) {
      case CachePolicy.IgnoreCache:
        this._requiresNetwork = true;
        break;

      case CachePolicy.CacheOnly:
        this._requiresCache = true;
        break;

      case CachePolicy.NetworkOnly:
        this._requiresNetwork = true;
        this._requiresCache = false;
        break;

      case CachePolicy.CacheElseNetwork:
        this._requiresNetwork = true;
        this._requiresCache = true;
        break;

      case CachePolicy.NetworkElseCache:
        this._requiresNetwork = true;
        this._requiresCache = true;
        break;

      case CachePolicy.CacheThenNetwork:
        this._requiresNetwork = true;
        this._requiresCache = true;
        break;

      default:
        throw new Error("ReactLiveQuery invalid CachePolicy " + String(this.opts.policy));
    }

    if (this._requiresNetwork && !ReactLiveQuery.isValidNetwork(this.opts.network)) {
      throw new Error("ReactLiveQuery CachePolicy " + String(this.opts.policy) + " requires valid network");
    }

    if (this._requiresCache && !ReactLiveQuery.isValidCache(this.opts.cache)) {
      throw new Error("ReactLiveQuery CachePolicy " + String(this.opts.policy) + " requires valid cache");
    }

    this._resultsMap = {};
  }

  var _proto = ReactLiveQuery.prototype;

  _proto.load = function load() {
    var _this2 = this;

    if (this._loadingP) {
      return this._loadingP;
    }

    if (this.status !== 'initial' && this.status !== 'active') {
      return Promise.resolve();
    }

    if (this.status === 'initial') {
      this.status = 'active';
    }

    var baseResults = this._results;
    var updateCache = false;
    var resultP = null;
    this.isLoading = true;

    switch (this.opts.policy) {
      case CachePolicy.IgnoreCache:
        resultP = this._loadFromNetwork();
        break;

      case CachePolicy.CacheOnly:
        resultP = this._loadFromCache();
        break;

      case CachePolicy.NetworkOnly:
        updateCache = true;
        resultP = this._loadFromNetwork();
        break;

      case CachePolicy.CacheElseNetwork:
        resultP = this._loadFromCache()["catch"](function () {
          return [];
        }).then(function (results) {
          if (results && results.length) {
            return results;
          } else {
            updateCache = true;
            return _this2._loadFromNetwork();
          }
        });
        break;

      case CachePolicy.NetworkElseCache:
        resultP = this._loadFromNetwork()["catch"](function () {
          return [];
        }).then(function (results) {
          if (results && results.length) {
            updateCache = true;
            return results;
          } else {
            return _this2._loadFromCache();
          }
        });
        break;

      case CachePolicy.CacheThenNetwork:
        {
          var cacheP = this._loadFromCache()["catch"](function () {
            return [];
          });

          var networkP = this._loadFromNetwork();

          resultP = cacheP.then(function (cacheResults) {
            if (cacheResults && cacheResults.length) {
              _this2._updateResults(cacheResults, baseResults, false, true);
            }

            updateCache = true;
            return networkP.then(function (networkResults) {
              if (networkResults) {
                return networkResults;
              } else {
                return _this2._loadFromCache();
              }
            });
          });
        }
        break;

      default:
        throw new Error("ReactLiveQuery invalid CachePolicy " + this.opts.policy);
    }

    this._loadingP = resultP;
    return resultP.then(function (results) {
      if (_this2.status === 'frozen') {
        return;
      }

      results = results || [];

      var updateP = _this2._updateResults(results, baseResults, updateCache, false);

      if (_this2.opts.paged) {
        _this2.opts.offset += results.length;

        if (results.length < _this2.opts.limit) {
          _this2.status = 'complete';
        } else {
          _this2.status = 'active';
        }
      } else {
        _this2.status = 'complete';
      }

      _this2._loadingP = null;
      _this2.isLoading = false;
      return updateP;
    }, function (err) {
      if (_this2.status === 'frozen') {
        return;
      }

      _this2.opts.debug('query error', _this2.opts.model, err);

      _this2.status = 'error';
      _this2._loadingP = null;
      _this2.isLoading = false;
    });
  };

  _proto.freeze = function freeze() {
    this.status = 'frozen';
  };

  _proto.refresh = function refresh() {
    var _this3 = this;

    if (this.status === 'frozen') {
      return Promise.resolve();
    }

    if (!ReactLiveQuery.isValidNetwork(this.opts.network)) {
      return Promise.reject(new Error("ReactLiveQuery.refresh not supported for this query " + this.opts.model));
    }

    if (this.status === 'error') {
      this.status = 'active';
    } else if (this.isLoadingInitialResults) {
      return Promise.resolve();
    }

    this.opts.debug(this.opts.model + " refresh");
    var options = {};

    if (this.opts.paged) {
      options.limit = this.opts.offset || this.opts.limit;
      options.offset = 0;
    }

    return this._loadFromNetwork(options).then(function (results) {
      if (results) {
        _this3._replaceResults(results);

        return _this3._updateCache(results);
      }
    }, function (err) {
      _this3.opts.debug(_this3.opts.model + " refresh error", err);
    });
  };

  _proto._updateResults = function _updateResults(results, baseResults, updateCache, isTempUpdateFromCache) {
    var _this4 = this;

    if (this.status === 'frozen') {
      return Promise.resolve();
    }

    if (results) {
      results = results.map(function (result) {
        var id = result[_this4.opts.key];

        if (!isTempUpdateFromCache) {
          var existing = _this4._resultsMap[id];

          if (existing) {
            result = existing;
          }
        }

        _this4._resultsMap[id] = result;
        return result;
      });
      var aggregateResults;

      if (this.opts.prepend) {
        results = results.reverse();
        aggregateResults = results.concat(baseResults.slice());
      } else {
        aggregateResults = baseResults.slice().concat(results);
      }

      this._results = uniqBy(aggregateResults, this.opts.key);
      this.opts.debug(this.opts.model + " added " + results.length + " results for a total of " + this._results.length);
      this.isLoading = isTempUpdateFromCache && this.isLoadingInitialResults && this.opts.paged && this._results.length < this.opts.limit;
      this.isLoadingInitialResults = false;

      if (updateCache && results.length > 0) {
        return this._updateCache(results);
      }
    }

    return Promise.resolve();
  };

  _proto._replaceResults = function _replaceResults(results, numUpdated) {
    var _this5 = this;

    if (numUpdated === void 0) {
      numUpdated = 0;
    }

    if (this.status === 'frozen') {
      return;
    }

    results = results || [];

    if (this.opts.prepend) {
      results = results.reverse();
    }

    this._resultsMap = {};
    results.forEach(function (result) {
      var id = result[_this5.opts.key];
      _this5._resultsMap[id] = result;
    });
    this.opts.debug(this.opts.model + " replaced " + this._results.length + " results with " + results.length + " (" + numUpdated + " updated)");
    this._results = results;

    if (this.opts.paged) {
      this.opts.offset = results.length;
    }
  };

  _proto._updateCache = function _updateCache(results) {
    var _this6 = this;

    if (this.status === 'frozen' || !this._requiresCache) {
      return Promise.resolve();
    }

    if (!ReactLiveQuery.isValidCache(this.opts.cache)) {
      return Promise.reject(new Error("_updateCache " + this.opts.model + " not supported for this query"));
    }

    return this.opts.cache.upsertBatch(results).then(function () {
      _this6.opts.debug(_this6.opts.model + " cached " + results.length + " docs");
    })["catch"](function (err) {
      _this6.opts.debug('error updating cache', _this6.opts.model, results.length, err);
    });
  };

  _proto._loadFromCache = function _loadFromCache(opts) {
    var _this7 = this;

    if (this.status === 'frozen') {
      return Promise.resolve();
    }

    if (!ReactLiveQuery.isValidCache(this.opts.cache)) {
      return Promise.reject(new Error("_loadFromCache " + this.opts.model + " not supported for this query"));
    }

    return this.opts.cache.find(_extends({
      offset: this.opts.paged && this.opts.offset,
      limit: this.opts.paged && this.opts.limit,
      sort: this.opts.sort
    }, opts)).then(function (results) {
      _this7.opts.debug(_this7.opts.model + " loaded " + results.length + " results from cache");

      return results;
    });
  };

  _proto._loadFromNetwork = function _loadFromNetwork(opts) {
    var _this8 = this;

    if (this.status === 'frozen') {
      return Promise.resolve();
    }

    if (!ReactLiveQuery.isValidNetwork(this.opts.network)) {
      return Promise.reject(new Error("_loadFromNetwork " + this.opts.model + " not supported for this query"));
    }

    var defaults = {};

    if (this.opts.paged) {
      defaults.offset = this.opts.offset;
      defaults.limit = this.opts.limit;
    }

    if (this.opts.sort) {
      defaults.sort = this.opts.sort;
    }

    var rpc = this.opts.network.find(Object.assign(defaults, opts));
    var wrappedRpc = NetworkUtils.addDebugLatency(rpc);
    return wrappedRpc.then(function (results) {
      _this8.opts.debug(_this8.opts.model + " loaded " + results.length + " results from network");

      return results;
    })["catch"](function (err) {
      _this8.opts.debug(_this8.opts.model + " error loading from network", err);

      throw err;
    });
  };

  _createClass(ReactLiveQuery, [{
    key: "result",
    get: function get() {
      if (this.opts.isSingleModel) {
        var results = this.results;
        return results && results.length && results[0];
      } else {
        throw new Error("ReactLiveQuery attempt to access invalid single result " + this.opts.model);
      }
    }
  }, {
    key: "results",
    get: function get() {
      if (this.opts.transforms.length) {
        var results = this._results;
        this.opts.transforms.forEach(function (transform) {
          results = transform(results);
        });
        return results;
      } else {
        return this._results;
      }
    }
  }]);

  return ReactLiveQuery;
}(), _class2$g.CachePolicy = CachePolicy, _class2$g.isValidNetwork = function (network) {
  return network && isFunction(network.find);
}, _class2$g.isValidCache = function (cache) {
  return cache && isFunction(cache.find) && isFunction(cache.upsertBatch);
}, _temp$i), (_applyDecoratedDescriptor(_class$k.prototype, "result", [computed], Object.getOwnPropertyDescriptor(_class$k.prototype, "result"), _class$k.prototype), _applyDecoratedDescriptor(_class$k.prototype, "results", [computed], Object.getOwnPropertyDescriptor(_class$k.prototype, "results"), _class$k.prototype), _descriptor$2 = _applyDecoratedDescriptor(_class$k.prototype, "_results", [_dec$f], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2$1 = _applyDecoratedDescriptor(_class$k.prototype, "isLoadingInitialResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3$1 = _applyDecoratedDescriptor(_class$k.prototype, "isLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4$1 = _applyDecoratedDescriptor(_class$k.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'initial';
  }
})), _class$k));

function isFunction(value) {
  return value && typeof value === 'function';
}

var _dec$g, _class$l, _class2$h, _temp$j;

var AuthGitHubPage = (_dec$g = inject('auth'), _dec$g(_class$l = observer(_class$l = (_temp$j = _class2$h = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthGitHubPage, _Component);

  function AuthGitHubPage() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: true,
      href: null
    };
    return _this;
  }

  var _proto = AuthGitHubPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    LocalStore.get('auth:location').then(function (href) {
      _this2.setState({
        href: href
      });

      _this2.props.auth.authWithGitHub(query).then(function () {
        _this2.setState({
          loading: false
        });
      }, function (err) {
        var _err$response, _err$response$data;

        _this2.setState({
          loading: false
        });

        debug(err);
        notification.error({
          message: 'Error authenticating with GitHub',
          description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message
        });
      });
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        loading = _this$state.loading,
        href = _this$state.href;

    if (loading) {
      return h("div", null, "Authenticating...");
    } else {
      return handleAuth({
        auth: this.props.auth,
        href: href
      });
    }
  };

  return AuthGitHubPage;
}(Component), _class2$h.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$j)) || _class$l) || _class$l);

var _dec$h, _class$m, _class2$i, _temp$k;

var AuthGooglePage = (_dec$h = inject('auth'), _dec$h(_class$m = observer(_class$m = (_temp$k = _class2$i = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthGooglePage, _Component);

  function AuthGooglePage() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: true,
      href: null
    };
    return _this;
  }

  var _proto = AuthGooglePage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    LocalStore.get('auth:location').then(function (href) {
      _this2.setState({
        href: href
      });

      _this2.props.auth.authWithGoogle(query).then(function () {
        _this2.setState({
          loading: false
        });
      }, function (err) {
        var _err$response, _err$response$data;

        _this2.setState({
          loading: false
        });

        debug(err);
        notification.error({
          message: 'Error authenticating with Google',
          description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message
        });
      });
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        loading = _this$state.loading,
        href = _this$state.href;

    if (loading) {
      return h("div", null, "Authenticating...");
    } else {
      return handleAuth({
        auth: this.props.auth,
        href: href
      });
    }
  };

  return AuthGooglePage;
}(Component), _class2$i.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$k)) || _class$m) || _class$m);

var _dec$i, _class$n, _class2$j, _temp$l;

var AuthSpotifyPage = (_dec$i = inject('auth'), _dec$i(_class$n = observer(_class$n = (_temp$l = _class2$j = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthSpotifyPage, _Component);

  function AuthSpotifyPage() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: true,
      href: null
    };
    return _this;
  }

  var _proto = AuthSpotifyPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    LocalStore.get('auth:location').then(function (href) {
      _this2.setState({
        href: href
      });

      _this2.props.auth.authWithSpotify(query).then(function () {
        _this2.setState({
          loading: false
        });
      }, function (err) {
        var _err$response, _err$response$data;

        _this2.setState({
          loading: false
        });

        debug(err);
        notification.error({
          message: 'Error authenticating with Spotify',
          description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message
        });
      });
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        loading = _this$state.loading,
        href = _this$state.href;

    if (loading) {
      return h("div", null, "Authenticating...");
    } else {
      return handleAuth({
        auth: this.props.auth,
        href: href
      });
    }
  };

  return AuthSpotifyPage;
}(Component), _class2$j.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$l)) || _class$n) || _class$n);

var _dec$j, _class$o, _class2$k, _temp$m;

var AuthLinkedInPage = (_dec$j = inject('auth'), _dec$j(_class$o = observer(_class$o = (_temp$m = _class2$k = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthLinkedInPage, _Component);

  function AuthLinkedInPage() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: true,
      href: null
    };
    return _this;
  }

  var _proto = AuthLinkedInPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    LocalStore.get('auth:location').then(function (href) {
      _this2.setState({
        href: href
      });

      _this2.props.auth.authWithLinkedIn(query).then(function () {
        _this2.setState({
          loading: false
        });
      }, function (err) {
        var _err$response, _err$response$data;

        _this2.setState({
          loading: false
        });

        debug(err);
        notification.error({
          message: 'Error authenticating with LinkedIn',
          description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message
        });
      });
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        loading = _this$state.loading,
        href = _this$state.href;

    if (loading) {
      return h("div", null, "Authenticating...");
    } else {
      return handleAuth({
        auth: this.props.auth,
        href: href
      });
    }
  };

  return AuthLinkedInPage;
}(Component), _class2$k.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$m)) || _class$o) || _class$o);

var _dec$k, _class$p, _class2$l, _temp$n;

var AuthTwitterPage = (_dec$k = inject('auth'), _dec$k(_class$p = observer(_class$p = (_temp$n = _class2$l = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthTwitterPage, _Component);

  function AuthTwitterPage() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: true,
      href: null
    };
    return _this;
  }

  var _proto = AuthTwitterPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    LocalStore.get('auth:location').then(function (href) {
      _this2.setState({
        href: href
      });

      _this2.props.auth.authWithTwitter(query).then(function () {
        _this2.setState({
          loading: false
        });
      }, function (err) {
        var _err$response, _err$response$data;

        _this2.setState({
          loading: false
        });

        debug(err);
        notification.error({
          message: 'Error authenticating with Twitter',
          description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message
        });
      });
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        loading = _this$state.loading,
        href = _this$state.href;

    if (loading) {
      return h("div", null, "Authenticating...");
    } else {
      return handleAuth({
        auth: this.props.auth,
        href: href
      });
    }
  };

  return AuthTwitterPage;
}(Component), _class2$l.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$n)) || _class$p) || _class$p);

var _dec$l, _class$q, _class2$m, _temp$o;

var AuthStripePage = (_dec$l = inject('auth'), _dec$l(_class$q = observer(_class$q = (_temp$o = _class2$m = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AuthStripePage, _Component);

  function AuthStripePage() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: true,
      href: null
    };
    return _this;
  }

  var _proto = AuthStripePage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    LocalStore.get('auth:location').then(function (href) {
      _this2.setState({
        href: href
      });

      _this2.props.auth.authWithStripe(query).then(function () {
        _this2.setState({
          loading: false
        });
      }, function (err) {
        var _err$response, _err$response$data;

        _this2.setState({
          loading: false
        });

        debug(err);
        notification.error({
          message: 'Error authenticating with Stripe',
          description: (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error) || err.message
        });
      });
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        loading = _this$state.loading,
        href = _this$state.href;

    if (loading) {
      return h("div", null, "Authenticating...");
    } else {
      return handleAuth({
        auth: this.props.auth,
        href: href
      });
    }
  };

  return AuthStripePage;
}(Component), _class2$m.propTypes = {
  auth: PropTypes.object.isRequired
}, _temp$o)) || _class$q) || _class$q);
global.h = React.createElement.bind(React);
export { API, AuthGitHubPage, AuthGooglePage, AuthLinkedInPage, AuthManager, AuthProviders, AuthSpotifyPage, AuthStripePage, AuthTwitterPage, AuthenticatedRoute, BillingSourcesSection, BillingUsageSection, BlankSection, CTAButton, CheckoutForm, CodeBlock, DashboardSection, EventEmitter, ImageZoom, InfiniteList, InvoicingSection, LiveServiceDemo, Loading, LocalStore, LoginForm, Logo, Markdown, NavFooter, NavHeader, NotFoundSection, Paper, PricingPlan, ProfileSection, ReactLiveQuery, RelativeTimeLabel, ScrollToTopOnMount, Section, SectionDivider, SignupForm, ThemeManager, UndrawSVG, authGitHub, authGoogle, authLinkedIn, authSpotify, authStripe, authTwitter, bootstrap, debug, env, getUpgradeLink, githubConfig, handleAuth, theme };